/*! middleware 2023-10-18 */
class LocalizationForm extends HTMLElement {
    constructor() {
        super();
        this.domLoaded = false;
        this.domLoadedCallbacks = [];
        this.elements = {
            input: null,
            button: null,
            panel: null
        };
        this.initDOMLoaded();
        this.init();
    }
    init() {
        this.subscribeDOMLoaded(() => {
            this.elements = {
                input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
                button: this.querySelector(".st_localization-button_JS"),
                panel: this.querySelector(".st_localization-list_JS")
            };
            this.elements.button.addEventListener("click", this.openSelector.bind(this));
            this.elements.button.addEventListener("focusout", this.closeSelector.bind(this));
            this.addEventListener("keyup", this.onContainerKeyUp.bind(this));
            this.querySelectorAll("a").forEach(item => item.addEventListener("click", this.onItemClick.bind(this)));
        });
    }
    initDOMLoaded() {
        if (document.readyState === "interactive" || document.readyState === "complete") {
            this.domLoaded = true;
            this.fireDOMLoadedCallbacks();
        } else {
            document.addEventListener("readystatechange", this.readyStateChange, false);
        }
    }
    readyStateChange = () => {
        if (document.readyState === "interactive") {
            this.domLoaded = true;
            this.fireDOMLoadedCallbacks();
        }
    };
    fireDOMLoadedCallbacks = () => {
        for (let i = 0; i < this.domLoadedCallbacks.length; i++) {
            this.domLoadedCallbacks[i]();
        }
    };
    subscribeDOMLoaded = cb => {
        if (this.domLoaded) {
            cb();
        } else {
            this.domLoadedCallbacks.push(cb);
        }
    };
    hidePanel() {
        this.elements.button.setAttribute("aria-expanded", "false");
        this.elements.panel.setAttribute("hidden", true);
    }
    onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== "ESCAPE") return;
        this.hidePanel();
        this.elements.button.focus();
    }
    onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector("form");
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
    }
    openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute("hidden");
        this.elements.button.setAttribute("aria-expanded", (this.elements.button.getAttribute("aria-expanded") === "false").toString());
    }
    closeSelector(event) {
        const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
        if (event.relatedTarget === null || shouldClose) {
            this.hidePanel();
        }
    }
}

customElements.define("localization-form", LocalizationForm);

var requirejs, require, define;

!function(global, setTimeout) {
    var req, s, head, baseElement, dataMain, src, interactiveScript, currentlyAddingScript, mainScript, subPath, version = "2.3.6", commentRegExp = /\/\*[\s\S]*?\*\/|([^:"'=]|^)\/\/.*$/gm, cjsRequireRegExp = /[^.]\s*require\s*\(\s*["']([^'"\s]+)["']\s*\)/g, jsSuffixRegExp = /\.js$/, currDirRegExp = /^\.\//, op = Object.prototype, ostring = op.toString, hasOwn = op.hasOwnProperty, isBrowser = !("undefined" == typeof window || "undefined" == typeof navigator || !window.document), isWebWorker = !isBrowser && "undefined" != typeof importScripts, readyRegExp = isBrowser && "PLAYSTATION 3" === navigator.platform ? /^complete$/ : /^(complete|loaded)$/, defContextName = "_", isOpera = "undefined" != typeof opera && "[object Opera]" === opera.toString(), contexts = {}, cfg = {}, globalDefQueue = [], useInteractive = !1;
    function commentReplace(e, t) {
        return t || "";
    }
    function isFunction(e) {
        return "[object Function]" === ostring.call(e);
    }
    function isArray(e) {
        return "[object Array]" === ostring.call(e);
    }
    function each(e, t) {
        var i;
        if (e) for (i = 0; i < e.length && (!e[i] || !t(e[i], i, e)); i += 1);
    }
    function eachReverse(e, t) {
        var i;
        if (e) for (i = e.length - 1; -1 < i && (!e[i] || !t(e[i], i, e)); i -= 1);
    }
    function hasProp(e, t) {
        return hasOwn.call(e, t);
    }
    function getOwn(e, t) {
        return hasProp(e, t) && e[t];
    }
    function eachProp(e, t) {
        var i;
        for (i in e) if (hasProp(e, i) && t(e[i], i)) break;
    }
    function mixin(i, e, r, n) {
        return e && eachProp(e, function(e, t) {
            !r && hasProp(i, t) || (!n || "object" != typeof e || !e || isArray(e) || isFunction(e) || e instanceof RegExp ? i[t] = e : (i[t] || (i[t] = {}), 
            mixin(i[t], e, r, n)));
        }), i;
    }
    function bind(e, t) {
        return function() {
            return t.apply(e, arguments);
        };
    }
    function scripts() {
        return document.getElementsByTagName("script");
    }
    function defaultOnError(e) {
        throw e;
    }
    function getGlobal(e) {
        if (!e) return e;
        var t = global;
        return each(e.split("."), function(e) {
            t = t[e];
        }), t;
    }
    function makeError(e, t, i, r) {
        var n = new Error(t + "\nhttps://requirejs.org/docs/errors.html#" + e);
        return n.requireType = e, n.requireModules = r, i && (n.originalError = i), 
        n;
    }
    if (void 0 === define) {
        if (void 0 !== requirejs) {
            if (isFunction(requirejs)) return;
            cfg = requirejs, requirejs = void 0;
        }
        void 0 === require || isFunction(require) || (cfg = require, require = void 0), 
        req = requirejs = function(e, t, i, r) {
            var n, o, a = defContextName;
            return isArray(e) || "string" == typeof e || (o = e, isArray(t) ? (e = t, 
            t = i, i = r) : e = []), o && o.context && (a = o.context), (n = getOwn(contexts, a)) || (n = contexts[a] = req.s.newContext(a)), 
            o && n.configure(o), n.require(e, t, i);
        }, req.config = function(e) {
            return req(e);
        }, req.nextTick = void 0 !== setTimeout ? function(e) {
            setTimeout(e, 4);
        } : function(e) {
            e();
        }, require || (require = req), req.version = version, req.jsExtRegExp = /^\/|:|\?|\.js$/, 
        req.isBrowser = isBrowser, s = req.s = {
            contexts: contexts,
            newContext: newContext
        }, req({}), each([ "toUrl", "undef", "defined", "specified" ], function(t) {
            req[t] = function() {
                var e = contexts[defContextName];
                return e.require[t].apply(e, arguments);
            };
        }), isBrowser && (head = s.head = document.getElementsByTagName("head")[0], 
        baseElement = document.getElementsByTagName("base")[0], baseElement && (head = s.head = baseElement.parentNode)), 
        req.onError = defaultOnError, req.createNode = function(e, t, i) {
            var r = e.xhtml ? document.createElementNS("http://www.w3.org/1999/xhtml", "html:script") : document.createElement("script");
            return r.type = e.scriptType || "text/javascript", r.charset = "utf-8", 
            r.async = !0, r;
        }, req.load = function(t, i, r) {
            var e, n = t && t.config || {};
            if (isBrowser) return (e = req.createNode(n, i, r)).setAttribute("data-requirecontext", t.contextName), 
            e.setAttribute("data-requiremodule", i), !e.attachEvent || e.attachEvent.toString && e.attachEvent.toString().indexOf("[native code") < 0 || isOpera ? (e.addEventListener("load", t.onScriptLoad, !1), 
            e.addEventListener("error", t.onScriptError, !1)) : (useInteractive = !0, 
            e.attachEvent("onreadystatechange", t.onScriptLoad)), e.src = r, n.onNodeCreated && n.onNodeCreated(e, n, i, r), 
            currentlyAddingScript = e, baseElement ? head.insertBefore(e, baseElement) : head.appendChild(e), 
            currentlyAddingScript = null, e;
            if (isWebWorker) try {
                setTimeout(function() {}, 0), importScripts(r), t.completeLoad(i);
            } catch (e) {
                t.onError(makeError("importscripts", "importScripts failed for " + i + " at " + r, e, [ i ]));
            }
        }, isBrowser && !cfg.skipDataMain && eachReverse(scripts(), function(e) {
            if (head || (head = e.parentNode), dataMain = e.getAttribute("data-main")) return mainScript = dataMain, 
            cfg.baseUrl || -1 !== mainScript.indexOf("!") || (mainScript = (src = mainScript.split("/")).pop(), 
            subPath = src.length ? src.join("/") + "/" : "./", cfg.baseUrl = subPath), 
            mainScript = mainScript.replace(jsSuffixRegExp, ""), req.jsExtRegExp.test(mainScript) && (mainScript = dataMain), 
            cfg.deps = cfg.deps ? cfg.deps.concat(mainScript) : [ mainScript ], 
            !0;
        }), define = function(e, i, t) {
            var r, n;
            "string" != typeof e && (t = i, i = e, e = null), isArray(i) || (t = i, 
            i = null), !i && isFunction(t) && (i = [], t.length && (t.toString().replace(commentRegExp, commentReplace).replace(cjsRequireRegExp, function(e, t) {
                i.push(t);
            }), i = (1 === t.length ? [ "require" ] : [ "require", "exports", "module" ]).concat(i))), 
            useInteractive && (r = currentlyAddingScript || getInteractiveScript()) && (e || (e = r.getAttribute("data-requiremodule")), 
            n = contexts[r.getAttribute("data-requirecontext")]), n ? (n.defQueue.push([ e, i, t ]), 
            n.defQueueMap[e] = !0) : globalDefQueue.push([ e, i, t ]);
        }, define.amd = {
            jQuery: !0
        }, req.exec = function(text) {
            return eval(text);
        }, req(cfg);
    }
    function newContext(u) {
        var i, e, l, c, d, g = {
            waitSeconds: 7,
            baseUrl: "./",
            paths: {},
            bundles: {},
            pkgs: {},
            shim: {},
            config: {}
        }, p = {}, f = {}, r = {}, h = [], m = {}, n = {}, v = {}, x = 1, b = 1;
        function q(e, t, i) {
            var r, n, o, a, s, u, c, d, p, f, l = t && t.split("/"), h = g.map, m = h && h["*"];
            if (e && (u = (e = e.split("/")).length - 1, g.nodeIdCompat && jsSuffixRegExp.test(e[u]) && (e[u] = e[u].replace(jsSuffixRegExp, "")), 
            "." === e[0].charAt(0) && l && (e = l.slice(0, l.length - 1).concat(e)), 
            function(e) {
                var t, i;
                for (t = 0; t < e.length; t++) if ("." === (i = e[t])) e.splice(t, 1), 
                t -= 1; else if (".." === i) {
                    if (0 === t || 1 === t && ".." === e[2] || ".." === e[t - 1]) continue;
                    0 < t && (e.splice(t - 1, 2), t -= 2);
                }
            }(e), e = e.join("/")), i && h && (l || m)) {
                e: for (o = (n = e.split("/")).length; 0 < o; o -= 1) {
                    if (s = n.slice(0, o).join("/"), l) for (a = l.length; 0 < a; a -= 1) if ((r = getOwn(h, l.slice(0, a).join("/"))) && (r = getOwn(r, s))) {
                        c = r, d = o;
                        break e;
                    }
                    !p && m && getOwn(m, s) && (p = getOwn(m, s), f = o);
                }
                !c && p && (c = p, d = f), c && (n.splice(0, d, c), e = n.join("/"));
            }
            return getOwn(g.pkgs, e) || e;
        }
        function E(t) {
            isBrowser && each(scripts(), function(e) {
                if (e.getAttribute("data-requiremodule") === t && e.getAttribute("data-requirecontext") === l.contextName) return e.parentNode.removeChild(e), 
                !0;
            });
        }
        function w(e) {
            var t = getOwn(g.paths, e);
            if (t && isArray(t) && 1 < t.length) return t.shift(), l.require.undef(e), 
            l.makeRequire(null, {
                skipMap: !0
            })([ e ]), !0;
        }
        function y(e) {
            var t, i = e ? e.indexOf("!") : -1;
            return -1 < i && (t = e.substring(0, i), e = e.substring(i + 1, e.length)), 
            [ t, e ];
        }
        function S(e, t, i, r) {
            var n, o, a, s, u = null, c = t ? t.name : null, d = e, p = !0, f = "";
            return e || (p = !1, e = "_@r" + (x += 1)), u = (s = y(e))[0], e = s[1], 
            u && (u = q(u, c, r), o = getOwn(m, u)), e && (u ? f = i ? e : o && o.normalize ? o.normalize(e, function(e) {
                return q(e, c, r);
            }) : -1 === e.indexOf("!") ? q(e, c, r) : e : (u = (s = y(f = q(e, c, r)))[0], 
            f = s[1], i = !0, n = l.nameToUrl(f))), {
                prefix: u,
                name: f,
                parentMap: t,
                unnormalized: !!(a = !u || o || i ? "" : "_unnormalized" + (b += 1)),
                url: n,
                originalName: d,
                isDefine: p,
                id: (u ? u + "!" + f : f) + a
            };
        }
        function k(e) {
            var t = e.id, i = getOwn(p, t);
            return i || (i = p[t] = new l.Module(e)), i;
        }
        function M(e, t, i) {
            var r = e.id, n = getOwn(p, r);
            !hasProp(m, r) || n && !n.defineEmitComplete ? (n = k(e)).error && "error" === t ? i(n.error) : n.on(t, i) : "defined" === t && i(m[r]);
        }
        function O(i, e) {
            var t = i.requireModules, r = !1;
            e ? e(i) : (each(t, function(e) {
                var t = getOwn(p, e);
                t && (t.error = i, t.events.error && (r = !0, t.emit("error", i)));
            }), r || req.onError(i));
        }
        function j() {
            globalDefQueue.length && (each(globalDefQueue, function(e) {
                var t = e[0];
                "string" == typeof t && (l.defQueueMap[t] = !0), h.push(e);
            }), globalDefQueue = []);
        }
        function P(e) {
            delete p[e], delete f[e];
        }
        function R() {
            var e, r, t = 1e3 * g.waitSeconds, n = t && l.startTime + t < new Date().getTime(), o = [], a = [], s = !1, u = !0;
            if (!i) {
                if (i = !0, eachProp(f, function(e) {
                    var t = e.map, i = t.id;
                    if (e.enabled && (t.isDefine || a.push(e), !e.error)) if (!e.inited && n) w(i) ? s = r = !0 : (o.push(i), 
                    E(i)); else if (!e.inited && e.fetched && t.isDefine && (s = !0, 
                    !t.prefix)) return u = !1;
                }), n && o.length) return (e = makeError("timeout", "Load timeout for modules: " + o, null, o)).contextName = l.contextName, 
                O(e);
                u && each(a, function(e) {
                    !function n(o, a, s) {
                        var e = o.map.id;
                        o.error ? o.emit("error", o.error) : (a[e] = !0, each(o.depMaps, function(e, t) {
                            var i = e.id, r = getOwn(p, i);
                            !r || o.depMatched[t] || s[i] || (getOwn(a, i) ? (o.defineDep(t, m[i]), 
                            o.check()) : n(r, a, s));
                        }), s[e] = !0);
                    }(e, {}, {});
                }), n && !r || !s || !isBrowser && !isWebWorker || d || (d = setTimeout(function() {
                    d = 0, R();
                }, 50)), i = !1;
            }
        }
        function a(e) {
            hasProp(m, e[0]) || k(S(e[0], null, !0)).init(e[1], e[2]);
        }
        function o(e, t, i, r) {
            e.detachEvent && !isOpera ? r && e.detachEvent(r, t) : e.removeEventListener(i, t, !1);
        }
        function s(e) {
            var t = e.currentTarget || e.srcElement;
            return o(t, l.onScriptLoad, "load", "onreadystatechange"), o(t, l.onScriptError, "error"), 
            {
                node: t,
                id: t && t.getAttribute("data-requiremodule")
            };
        }
        function T() {
            var e;
            for (j(); h.length; ) {
                if (null === (e = h.shift())[0]) return O(makeError("mismatch", "Mismatched anonymous define() module: " + e[e.length - 1]));
                a(e);
            }
            l.defQueueMap = {};
        }
        return c = {
            require: function(e) {
                return e.require ? e.require : e.require = l.makeRequire(e.map);
            },
            exports: function(e) {
                if (e.usingExports = !0, e.map.isDefine) return e.exports ? m[e.map.id] = e.exports : e.exports = m[e.map.id] = {};
            },
            module: function(e) {
                return e.module ? e.module : e.module = {
                    id: e.map.id,
                    uri: e.map.url,
                    config: function() {
                        return getOwn(g.config, e.map.id) || {};
                    },
                    exports: e.exports || (e.exports = {})
                };
            }
        }, (e = function(e) {
            this.events = getOwn(r, e.id) || {}, this.map = e, this.shim = getOwn(g.shim, e.id), 
            this.depExports = [], this.depMaps = [], this.depMatched = [], this.pluginMaps = {}, 
            this.depCount = 0;
        }).prototype = {
            init: function(e, t, i, r) {
                r = r || {}, this.inited || (this.factory = t, i ? this.on("error", i) : this.events.error && (i = bind(this, function(e) {
                    this.emit("error", e);
                })), this.depMaps = e && e.slice(0), this.errback = i, this.inited = !0, 
                this.ignore = r.ignore, r.enabled || this.enabled ? this.enable() : this.check());
            },
            defineDep: function(e, t) {
                this.depMatched[e] || (this.depMatched[e] = !0, this.depCount -= 1, 
                this.depExports[e] = t);
            },
            fetch: function() {
                if (!this.fetched) {
                    this.fetched = !0, l.startTime = new Date().getTime();
                    var e = this.map;
                    if (!this.shim) return e.prefix ? this.callPlugin() : this.load();
                    l.makeRequire(this.map, {
                        enableBuildCallback: !0
                    })(this.shim.deps || [], bind(this, function() {
                        return e.prefix ? this.callPlugin() : this.load();
                    }));
                }
            },
            load: function() {
                var e = this.map.url;
                n[e] || (n[e] = !0, l.load(this.map.id, e));
            },
            check: function() {
                if (this.enabled && !this.enabling) {
                    var t, e, i = this.map.id, r = this.depExports, n = this.exports, o = this.factory;
                    if (this.inited) {
                        if (this.error) this.emit("error", this.error); else if (!this.defining) {
                            if (this.defining = !0, this.depCount < 1 && !this.defined) {
                                if (isFunction(o)) {
                                    if (this.events.error && this.map.isDefine || req.onError !== defaultOnError) try {
                                        n = l.execCb(i, o, r, n);
                                    } catch (e) {
                                        t = e;
                                    } else n = l.execCb(i, o, r, n);
                                    if (this.map.isDefine && void 0 === n && ((e = this.module) ? n = e.exports : this.usingExports && (n = this.exports)), 
                                    t) return t.requireMap = this.map, t.requireModules = this.map.isDefine ? [ this.map.id ] : null, 
                                    t.requireType = this.map.isDefine ? "define" : "require", 
                                    O(this.error = t);
                                } else n = o;
                                if (this.exports = n, this.map.isDefine && !this.ignore && (m[i] = n, 
                                req.onResourceLoad)) {
                                    var a = [];
                                    each(this.depMaps, function(e) {
                                        a.push(e.normalizedMap || e);
                                    }), req.onResourceLoad(l, this.map, a);
                                }
                                P(i), this.defined = !0;
                            }
                            this.defining = !1, this.defined && !this.defineEmitted && (this.defineEmitted = !0, 
                            this.emit("defined", this.exports), this.defineEmitComplete = !0);
                        }
                    } else hasProp(l.defQueueMap, i) || this.fetch();
                }
            },
            callPlugin: function() {
                var u = this.map, c = u.id, e = S(u.prefix);
                this.depMaps.push(e), M(e, "defined", bind(this, function(e) {
                    var o, t, i, r = getOwn(v, this.map.id), n = this.map.name, a = this.map.parentMap ? this.map.parentMap.name : null, s = l.makeRequire(u.parentMap, {
                        enableBuildCallback: !0
                    });
                    return this.map.unnormalized ? (e.normalize && (n = e.normalize(n, function(e) {
                        return q(e, a, !0);
                    }) || ""), M(t = S(u.prefix + "!" + n, this.map.parentMap, !0), "defined", bind(this, function(e) {
                        this.map.normalizedMap = t, this.init([], function() {
                            return e;
                        }, null, {
                            enabled: !0,
                            ignore: !0
                        });
                    })), void ((i = getOwn(p, t.id)) && (this.depMaps.push(t), this.events.error && i.on("error", bind(this, function(e) {
                        this.emit("error", e);
                    })), i.enable()))) : r ? (this.map.url = l.nameToUrl(r), void this.load()) : ((o = bind(this, function(e) {
                        this.init([], function() {
                            return e;
                        }, null, {
                            enabled: !0
                        });
                    })).error = bind(this, function(e) {
                        this.inited = !0, (this.error = e).requireModules = [ c ], 
                        eachProp(p, function(e) {
                            0 === e.map.id.indexOf(c + "_unnormalized") && P(e.map.id);
                        }), O(e);
                    }), o.fromText = bind(this, function(e, t) {
                        var i = u.name, r = S(i), n = useInteractive;
                        t && (e = t), n && (useInteractive = !1), k(r), hasProp(g.config, c) && (g.config[i] = g.config[c]);
                        try {
                            req.exec(e);
                        } catch (e) {
                            return O(makeError("fromtexteval", "fromText eval for " + c + " failed: " + e, e, [ c ]));
                        }
                        n && (useInteractive = !0), this.depMaps.push(r), l.completeLoad(i), 
                        s([ i ], o);
                    }), void e.load(u.name, s, o, g));
                })), l.enable(e, this), this.pluginMaps[e.id] = e;
            },
            enable: function() {
                (f[this.map.id] = this).enabled = !0, this.enabling = !0, each(this.depMaps, bind(this, function(e, t) {
                    var i, r, n;
                    if ("string" == typeof e) {
                        if (e = S(e, this.map.isDefine ? this.map : this.map.parentMap, !1, !this.skipMap), 
                        this.depMaps[t] = e, n = getOwn(c, e.id)) return void (this.depExports[t] = n(this));
                        this.depCount += 1, M(e, "defined", bind(this, function(e) {
                            this.undefed || (this.defineDep(t, e), this.check());
                        })), this.errback ? M(e, "error", bind(this, this.errback)) : this.events.error && M(e, "error", bind(this, function(e) {
                            this.emit("error", e);
                        }));
                    }
                    i = e.id, r = p[i], hasProp(c, i) || !r || r.enabled || l.enable(e, this);
                })), eachProp(this.pluginMaps, bind(this, function(e) {
                    var t = getOwn(p, e.id);
                    t && !t.enabled && l.enable(e, this);
                })), this.enabling = !1, this.check();
            },
            on: function(e, t) {
                var i = this.events[e];
                i || (i = this.events[e] = []), i.push(t);
            },
            emit: function(e, t) {
                each(this.events[e], function(e) {
                    e(t);
                }), "error" === e && delete this.events[e];
            }
        }, (l = {
            config: g,
            contextName: u,
            registry: p,
            defined: m,
            urlFetched: n,
            defQueue: h,
            defQueueMap: {},
            Module: e,
            makeModuleMap: S,
            nextTick: req.nextTick,
            onError: O,
            configure: function(e) {
                if (e.baseUrl && "/" !== e.baseUrl.charAt(e.baseUrl.length - 1) && (e.baseUrl += "/"), 
                "string" == typeof e.urlArgs) {
                    var i = e.urlArgs;
                    e.urlArgs = function(e, t) {
                        return (-1 === t.indexOf("?") ? "?" : "&") + i;
                    };
                }
                var r = g.shim, n = {
                    paths: !0,
                    bundles: !0,
                    config: !0,
                    map: !0
                };
                eachProp(e, function(e, t) {
                    n[t] ? (g[t] || (g[t] = {}), mixin(g[t], e, !0, !0)) : g[t] = e;
                }), e.bundles && eachProp(e.bundles, function(e, t) {
                    each(e, function(e) {
                        e !== t && (v[e] = t);
                    });
                }), e.shim && (eachProp(e.shim, function(e, t) {
                    isArray(e) && (e = {
                        deps: e
                    }), !e.exports && !e.init || e.exportsFn || (e.exportsFn = l.makeShimExports(e)), 
                    r[t] = e;
                }), g.shim = r), e.packages && each(e.packages, function(e) {
                    var t;
                    t = (e = "string" == typeof e ? {
                        name: e
                    } : e).name, e.location && (g.paths[t] = e.location), g.pkgs[t] = e.name + "/" + (e.main || "main").replace(currDirRegExp, "").replace(jsSuffixRegExp, "");
                }), eachProp(p, function(e, t) {
                    e.inited || e.map.unnormalized || (e.map = S(t, null, !0));
                }), (e.deps || e.callback) && l.require(e.deps || [], e.callback);
            },
            makeShimExports: function(t) {
                return function() {
                    var e;
                    return t.init && (e = t.init.apply(global, arguments)), e || t.exports && getGlobal(t.exports);
                };
            },
            makeRequire: function(o, a) {
                function s(e, t, i) {
                    var r, n;
                    return a.enableBuildCallback && t && isFunction(t) && (t.__requireJsBuild = !0), 
                    "string" == typeof e ? isFunction(t) ? O(makeError("requireargs", "Invalid require call"), i) : o && hasProp(c, e) ? c[e](p[o.id]) : req.get ? req.get(l, e, o, s) : (r = S(e, o, !1, !0).id, 
                    hasProp(m, r) ? m[r] : O(makeError("notloaded", 'Module name "' + r + '" has not been loaded yet for context: ' + u + (o ? "" : ". Use require([])")))) : (T(), 
                    l.nextTick(function() {
                        T(), (n = k(S(null, o))).skipMap = a.skipMap, n.init(e, t, i, {
                            enabled: !0
                        }), R();
                    }), s);
                }
                return a = a || {}, mixin(s, {
                    isBrowser: isBrowser,
                    toUrl: function(e) {
                        var t, i = e.lastIndexOf("."), r = e.split("/")[0];
                        return -1 !== i && (!("." === r || ".." === r) || 1 < i) && (t = e.substring(i, e.length), 
                        e = e.substring(0, i)), l.nameToUrl(q(e, o && o.id, !0), t, !0);
                    },
                    defined: function(e) {
                        return hasProp(m, S(e, o, !1, !0).id);
                    },
                    specified: function(e) {
                        return e = S(e, o, !1, !0).id, hasProp(m, e) || hasProp(p, e);
                    }
                }), o || (s.undef = function(i) {
                    j();
                    var e = S(i, o, !0), t = getOwn(p, i);
                    t.undefed = !0, E(i), delete m[i], delete n[e.url], delete r[i], 
                    eachReverse(h, function(e, t) {
                        e[0] === i && h.splice(t, 1);
                    }), delete l.defQueueMap[i], t && (t.events.defined && (r[i] = t.events), 
                    P(i));
                }), s;
            },
            enable: function(e) {
                getOwn(p, e.id) && k(e).enable();
            },
            completeLoad: function(e) {
                var t, i, r, n = getOwn(g.shim, e) || {}, o = n.exports;
                for (j(); h.length; ) {
                    if (null === (i = h.shift())[0]) {
                        if (i[0] = e, t) break;
                        t = !0;
                    } else i[0] === e && (t = !0);
                    a(i);
                }
                if (l.defQueueMap = {}, r = getOwn(p, e), !t && !hasProp(m, e) && r && !r.inited) {
                    if (!(!g.enforceDefine || o && getGlobal(o))) return w(e) ? void 0 : O(makeError("nodefine", "No define call for " + e, null, [ e ]));
                    a([ e, n.deps || [], n.exportsFn ]);
                }
                R();
            },
            nameToUrl: function(e, t, i) {
                var r, n, o, a, s, u, c = getOwn(g.pkgs, e);
                if (c && (e = c), u = getOwn(v, e)) return l.nameToUrl(u, t, i);
                if (req.jsExtRegExp.test(e)) a = e + (t || ""); else {
                    for (r = g.paths, o = (n = e.split("/")).length; 0 < o; o -= 1) if (s = getOwn(r, n.slice(0, o).join("/"))) {
                        isArray(s) && (s = s[0]), n.splice(0, o, s);
                        break;
                    }
                    a = n.join("/"), a = ("/" === (a += t || (/^data\:|^blob\:|\?/.test(a) || i ? "" : ".js")).charAt(0) || a.match(/^[\w\+\.\-]+:/) ? "" : g.baseUrl) + a;
                }
                return g.urlArgs && !/^blob\:/.test(a) ? a + g.urlArgs(e, a) : a;
            },
            load: function(e, t) {
                req.load(l, e, t);
            },
            execCb: function(e, t, i, r) {
                return t.apply(r, i);
            },
            onScriptLoad: function(e) {
                if ("load" === e.type || readyRegExp.test((e.currentTarget || e.srcElement).readyState)) {
                    interactiveScript = null;
                    var t = s(e);
                    l.completeLoad(t.id);
                }
            },
            onScriptError: function(e) {
                var i = s(e);
                if (!w(i.id)) {
                    var r = [];
                    return eachProp(p, function(e, t) {
                        0 !== t.indexOf("_@r") && each(e.depMaps, function(e) {
                            if (e.id === i.id) return r.push(t), !0;
                        });
                    }), O(makeError("scripterror", 'Script error for "' + i.id + (r.length ? '", needed by: ' + r.join(", ") : '"'), e, [ i.id ]));
                }
            }
        }).require = l.makeRequire(), l;
    }
    function getInteractiveScript() {
        return interactiveScript && "interactive" === interactiveScript.readyState || eachReverse(scripts(), function(e) {
            if ("interactive" === e.readyState) return interactiveScript = e;
        }), interactiveScript;
    }
}(this, "undefined" == typeof setTimeout ? void 0 : setTimeout);

var __assign = this && this.__assign || function() {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

var __generator = this && this.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        throw: verb(1),
        return: verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([ n, v ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 
            0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [ op[0] & 2, t.value ];
            switch (op[0]) {
              case 0:
              case 1:
                t = op;
                break;

              case 4:
                _.label++;
                return {
                    value: op[1],
                    done: false
                };

              case 5:
                _.label++;
                y = op[1];
                op = [ 0 ];
                continue;

              case 7:
                op = _.ops.pop();
                _.trys.pop();
                continue;

              default:
                if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _ = 0;
                    continue;
                }
                if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                    _.label = op[1];
                    break;
                }
                if (op[0] === 6 && _.label < t[1]) {
                    _.label = t[1];
                    t = op;
                    break;
                }
                if (t && _.label < t[2]) {
                    _.label = t[2];
                    _.ops.push(op);
                    break;
                }
                if (t[2]) _.ops.pop();
                _.trys.pop();
                continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [ 6, e ];
            y = 0;
        } finally {
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};

define("static/static", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StStatic = void 0;
    var StStatic = function() {
        function StStatic() {
            var _this = this;
            this.className = "Static";
            this.shopConfig = window.stAppConfig;
            this.defaultAlias = window.stAppConfig.options.defaultAlias || "1";
            this.companyName = window.stAppConfig.options.companyName || "New U Life";
            this.init = function() {};
            this.apiRoot = this.shopConfig.apiRoot;
            this.endpoint = {
                "replicated-site-info": this.apiRoot + "/rep/replicated-site-info",
                "set-customer-info": this.apiRoot + "/enrollment/set-customer-info",
                "set-enrollment-kit": this.apiRoot + "/enrollment/set-enrollment-kit",
                "account-info": this.apiRoot + "/rep/account-info",
                "sso-login": this.apiRoot + "/rep/backoffice",
                "update-acc-info": this.apiRoot + "/rep/update-account-info",
                "set-affiliate-kit": this.apiRoot + "/enrollment/set-affiliate-kit",
                "suggested-referrers": this.apiRoot + "/rep/suggested-reps",
                "referrer-search": this.apiRoot + "/rep/search-reps",
                "multipass-link": this.apiRoot + "/customers/multipass-link",
                "search-rep-info": this.apiRoot + "/customers/search-rep-info",
                "search-rep-id": this.apiRoot + "/customers/search-rep-id",
                "get-rep": this.apiRoot + "/customers/get-rep",
                "get-rep-site-info": this.apiRoot + "/customers/get-rep-site-info",
                "retail-account-info": this.apiRoot + "/customers/account-info",
                "shopping-on-behalf": this.apiRoot + "/customers/shopping-on-behalf",
                "get-sob-customer": this.apiRoot + "/customers/get-sob-customer",
                "bydesign-sso": this.apiRoot + "/customers/bydesign-sso",
                "loyalty-program": this.apiRoot + "/customers/loyalty-retail-guid",
                "account-addresses": "/account/addresses",
                "agree-to-terms": this.apiRoot + "/customers/agree-to-terms",
                "get-terms": this.apiRoot + "/customers/get-terms",
                "sob-checkout": this.apiRoot + "/customers/sob-checkout",
                "variant-meta": this.apiRoot + "/customers/variant-meta",
                "rep-info": this.apiRoot + "/customers/rep-info"
            };
            this.obtainStaticEndpoints = function() {
                return _this.endpoint;
            };
            this.obtainMainScope = function() {
                return window.stApp;
            };
            this.obtainCart = function() {
                return window.shopifyCartData;
            };
        }
        Object.defineProperty(StStatic, "Instance", {
            get: function() {
                return this._instance || (this._instance = new this());
            },
            enumerable: false,
            configurable: true
        });
        return StStatic;
    }();
    exports.StStatic = StStatic;
});

define("general-methods/object-formatting", [ "require", "exports", "general-methods/ajax", "static/static" ], function(require, exports, ajax_1, static_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StObjectFormatting = void 0;
    var StObjectFormatting = function() {
        function StObjectFormatting() {
            this.className = "stObjectFormatting";
            this.endpoint = static_1.StStatic.Instance.obtainStaticEndpoints();
            this.ajax = ajax_1.StAjax.Instance;
        }
        Object.defineProperty(StObjectFormatting, "Instance", {
            get: function() {
                return this._instance || (this._instance = new this());
            },
            enumerable: false,
            configurable: true
        });
        StObjectFormatting.prototype.convertObjectToQueryString = function(object) {
            var string = "", i = 0;
            for (var j in object) {
                var s = encodeURIComponent(j) + "=" + encodeURIComponent(object[j]);
                string += i > 0 ? "&" + s : s;
                i++;
            }
            return string;
        };
        StObjectFormatting.prototype.convertQueryStringToObject = function(query) {
            query = typeof query != "string" ? "" : query.substr(query.indexOf("?") + 1);
            var query_string = {};
            if (query !== "") {
                var vars = query.split("&");
                for (var i = 0; i < vars.length; i++) {
                    var pair = vars[i].split("=");
                    var key = decodeURIComponent(pair[0]);
                    var value = decodeURIComponent(pair[1]);
                    if (typeof query_string[key] === "undefined") {
                        query_string[key] = decodeURIComponent(value);
                    } else if (typeof query_string[key] === "string") {
                        query_string[key] = [ query_string[key], decodeURIComponent(value) ];
                    } else {
                        query_string[key].push(decodeURIComponent(value));
                    }
                }
            } else {
                console.warn("Invalid query string supplied to convertQueryStringToObject.");
            }
            return query_string;
        };
        return StObjectFormatting;
    }();
    exports.StObjectFormatting = StObjectFormatting;
});

define("general-methods/ajax", [ "require", "exports", "general-methods/object-formatting", "static/static" ], function(require, exports, object_formatting_1, static_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAjax = void 0;
    var StAjax = function() {
        function StAjax() {
            this.endpoint = static_2.StStatic.Instance.obtainStaticEndpoints();
        }
        Object.defineProperty(StAjax, "Instance", {
            get: function() {
                return this._instance || (this._instance = new this());
            },
            enumerable: false,
            configurable: true
        });
        StAjax.prototype.determineContentType = function(contentType) {
            var output = {
                type: "application/x-www-form-urlencoded",
                prepFn: object_formatting_1.StObjectFormatting.Instance.convertObjectToQueryString
            };
            switch (contentType) {
              case "form":
                output.type = "application/x-www-form-urlencoded";
                output.prepFn = object_formatting_1.StObjectFormatting.Instance.convertObjectToQueryString;
                break;

              case "json":
                output.type = "application/json";
                output.prepFn = JSON.stringify;
                break;
            }
            return output;
        };
        StAjax.prototype.send = function(options) {
            var fnReference = this;
            if (typeof options == "object") {
                var defaultOptions = {
                    endpoint: "",
                    method: "POST",
                    contentType: "json",
                    data: {},
                    callback: function() {},
                    callbackParams: [],
                    rejectCallback: function() {},
                    rejectCallbackParams: []
                };
                var completeOptions_1 = __assign(__assign({}, defaultOptions), options);
                var contentTypeData = this.determineContentType(completeOptions_1.contentType);
                var requestMethod = completeOptions_1.method.toUpperCase();
                var allowedMethods = [ "POST", "GET", "PUT", "DELETE" ];
                completeOptions_1.method = allowedMethods.indexOf(requestMethod) >= 0 ? requestMethod : "POST";
                var request_1 = new XMLHttpRequest();
                request_1.open(completeOptions_1.method, completeOptions_1.endpoint, true);
                request_1.withCredentials = true;
                request_1.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                request_1.setRequestHeader("Content-Type", contentTypeData.type);
                request_1.setRequestHeader("credentials", "include");
                request_1.onreadystatechange = function() {
                    if (request_1.readyState === 4) {
                        completeOptions_1.callbackParams.unshift(request_1);
                        completeOptions_1.callback.apply(fnReference, completeOptions_1.callbackParams);
                    } else {
                        completeOptions_1.rejectCallback.apply(fnReference, completeOptions_1.rejectCallbackParams);
                    }
                };
                request_1.send(contentTypeData.prepFn(completeOptions_1.data));
                return request_1;
            }
        };
        return StAjax;
    }();
    exports.StAjax = StAjax;
});

define("di-container/st-module", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("general-methods/general-methods", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StGeneralMethods = void 0;
    var StGeneralMethods = function() {
        function StGeneralMethods() {
            var _this = this;
            this.className = "StGeneralMethods";
            this.domLoaded = false;
            this.domLoadedCallbacks = [];
            this.readyStateChange = function() {
                if (document.readyState === "interactive") {
                    _this.domLoaded = true;
                    _this.fireDOMLoadedCallbacks();
                }
            };
            this.fireDOMLoadedCallbacks = function() {
                for (var i = 0; i < _this.domLoadedCallbacks.length; i++) {
                    _this.domLoadedCallbacks[i]();
                }
            };
            this.subscribeDOMLoaded = function(cb) {
                if (_this.domLoaded) {
                    cb();
                } else {
                    _this.domLoadedCallbacks.push(cb);
                }
            };
        }
        Object.defineProperty(StGeneralMethods, "Instance", {
            get: function() {
                return this._instance || (this._instance = new this());
            },
            enumerable: false,
            configurable: true
        });
        StGeneralMethods.prototype.initDOMLoaded = function() {
            if (document.readyState === "interactive" || document.readyState === "complete") {
                this.domLoaded = true;
                this.fireDOMLoadedCallbacks();
            } else {
                document.addEventListener("readystatechange", this.readyStateChange, false);
            }
        };
        StGeneralMethods.prototype.getClosestByClass = function(el, cls) {
            var res = el;
            while ((res = res.parentElement) && !res.classList.contains(cls));
            return res;
        };
        StGeneralMethods.prototype.commaFormattedPrice = function(amount, delimiter) {
            delimiter = typeof delimiter === "string" ? delimiter : ",";
            var a = amount.split(".", 2);
            var d = a[1];
            var i = parseInt(a[0]);
            if (isNaN(i)) {
                return "";
            }
            var minus = "";
            if (i < 0) {
                minus = "-";
            }
            i = Math.abs(i);
            var n = new String(i);
            var a = [];
            while (n.length > 3) {
                var nn = n.substr(n.length - 3);
                a.unshift(nn);
                n = n.substr(0, n.length - 3);
            }
            if (n.length > 0) {
                a.unshift(n);
            }
            n = a.join(delimiter);
            if (d.length < 1) {
                amount = n;
            } else {
                amount = n + "." + d;
            }
            amount = minus + amount;
            return amount;
        };
        return StGeneralMethods;
    }();
    exports.StGeneralMethods = StGeneralMethods;
});

define("checkout/checkout", [ "require", "exports", "general-methods/general-methods", "general-methods/ajax", "static/static" ], function(require, exports, general_methods_1, ajax_2, static_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCheckout = void 0;
    var StCheckout = function() {
        function StCheckout() {
            var _this_1 = this;
            this.className = "Checkout";
            this.init = function() {
                var _this = _this_1;
                _this_1.generalMethods.subscribeDOMLoaded(function() {
                    _this.koreaSpecificValidation();
                });
            };
            this.koreaSpecificValidation = function() {
                var country = window.stAppConfig.country;
                if (country.toLowerCase().includes("korea")) {
                    var _this_2 = _this_1;
                    var alertTimeout_1;
                    var buttonReEnableTimeout_1;
                    var validationErrors_1 = "";
                    var firstNameInput_1 = document.querySelector("#checkout_shipping_address_first_name");
                    var lastNameInput_1 = document.querySelector("#checkout_shipping_address_last_name");
                    var addressLine1Input_1 = document.querySelector("#checkout_shipping_address_address1");
                    var addressLine2Input_1 = document.querySelector("#checkout_shipping_address_address2");
                    var cityInput_1 = document.querySelector("#checkout_shipping_address_city");
                    var postalCodeInput_1 = document.querySelector("#checkout_shipping_address_zip");
                    var checkoutForm = document.querySelector(".edit_checkout");
                    var nameProvinceAndCityRegex_1 = new RegExp(/^[\u3131-\uD79D\s]+([a-z]0-9-\(\)]*){0}$/i);
                    var addressRegex_1 = new RegExp(/^[\u3131-\uD79D0-9\s-()]*([a-z][\u3131-\uD79D0-9\s-()]*){0,3}$/i);
                    if (!!checkoutForm) {
                        checkoutForm.addEventListener("submit", function(e) {
                            validationErrors_1 = "";
                            if (!!firstNameInput_1 && !!lastNameInput_1) {
                                var firstNameOnlyHangul = nameProvinceAndCityRegex_1.test(firstNameInput_1.value);
                                var lastNameOnlyHangul = nameProvinceAndCityRegex_1.test(lastNameInput_1.value);
                                if (!firstNameOnlyHangul || !lastNameOnlyHangul) {
                                    e.preventDefault();
                                    validationErrors_1 = validationErrors_1.concat("First and last name fields can only contain hangul characters!");
                                }
                            }
                            if (!!addressLine1Input_1 && !!addressLine2Input_1 && !!cityInput_1) {
                                var numOfNonHangulAddress1 = addressRegex_1.test(addressLine1Input_1.value);
                                var numOfNonHangulAddress2 = addressRegex_1.test(addressLine2Input_1.value);
                                var numOfNonHangulCity = nameProvinceAndCityRegex_1.test(cityInput_1.value);
                                if (!numOfNonHangulAddress1 || !numOfNonHangulAddress2 || !numOfNonHangulCity) {
                                    e.preventDefault();
                                    if (validationErrors_1.length > 0) {
                                        validationErrors_1 = validationErrors_1.concat("<br/><br/>");
                                    }
                                    validationErrors_1 = validationErrors_1.concat("Address fields can only contain up to 3 non-hangul characters!");
                                }
                            }
                            if (!!postalCodeInput_1 && postalCodeInput_1.value.length !== 5) {
                                e.preventDefault();
                                if (validationErrors_1.length > 0) {
                                    validationErrors_1 = validationErrors_1.concat("<br/><br/>");
                                }
                                validationErrors_1 = validationErrors_1.concat("Postal Code must have 5 digits!");
                            }
                            clearTimeout(buttonReEnableTimeout_1);
                            buttonReEnableTimeout_1 = setTimeout(function() {
                                _this_2.reEnableSubmitButton();
                                if (!!validationErrors_1) {
                                    _this_2.showAlert(validationErrors_1, alertTimeout_1);
                                }
                            }, 600);
                        });
                    }
                }
            };
            this.reEnableSubmitButton = function() {
                var button = document.querySelector("#continue_button");
                button.removeAttribute("aria-busy");
                button.classList.remove("btn--loading");
                button.disabled = false;
            };
            this.showAlert = function(message, alertTimeout) {
                var alert = document.querySelector(".st_alert_JS");
                if (!!alert) {
                    var alertMsg = alert.querySelector(".st_alert-msg_JS");
                    alertMsg.innerHTML = message;
                    alert.style.display = "block";
                    clearTimeout(alertTimeout);
                    alertTimeout = setTimeout(function() {
                        alert.style.display = "none";
                    }, 3e3);
                }
            };
            this.generalMethods = general_methods_1.StGeneralMethods.Instance;
            this.static = static_3.StStatic.Instance;
            this.endpoint = this.static.obtainStaticEndpoints();
            this.ajax = ajax_2.StAjax.Instance;
            this.init();
        }
        Object.defineProperty(StCheckout, "Instance", {
            get: function() {
                return this._instance || (this._instance = new this());
            },
            enumerable: false,
            configurable: true
        });
        return StCheckout;
    }();
    exports.StCheckout = StCheckout;
});

define("general-methods/url", [ "require", "exports", "static/static", "general-methods/ajax" ], function(require, exports, static_4, ajax_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StUrl = void 0;
    var StUrl = function() {
        function StUrl() {
            var _this = this;
            this.className = "stUrl";
            this.parseUrlParams = function(query) {
                query = typeof query != "string" ? "" : query.substr(query.indexOf("?") + 1);
                var query_string = {};
                if (query !== "") {
                    var lets = query.split("&");
                    for (var i = 0; i < lets.length; i++) {
                        var pair = lets[i].split("=");
                        var key = decodeURIComponent(pair[0]);
                        var value = decodeURIComponent(pair[1]);
                        if (typeof query_string[key] === "undefined") {
                            query_string[key] = decodeURIComponent(value);
                        } else if (typeof query_string[key] === "string") {
                            query_string[key] = [ query_string[key], decodeURIComponent(value) ];
                        } else {
                            query_string[key].push(decodeURIComponent(value));
                        }
                    }
                } else {
                    console.warn("Invalid query string supplied to parseUrlParams.");
                }
                return query_string;
            };
            this.serializeUrlParams = function(obj) {
                var str = [];
                for (var p in obj) {
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                }
                return "?" + str.join("&");
            };
            this.browserHistoryPush = function(rootURL, urlParams) {
                var serializedUrlParams = _this.serializeUrlParams(urlParams);
                window.history.replaceState(urlParams, "", rootURL + serializedUrlParams);
            };
            this.endpoint = static_4.StStatic.Instance.obtainStaticEndpoints();
            this.cart = static_4.StStatic.Instance.obtainCart();
            this.ajax = ajax_3.StAjax.Instance;
        }
        Object.defineProperty(StUrl, "Instance", {
            get: function() {
                return this._instance || (this._instance = new this());
            },
            enumerable: false,
            configurable: true
        });
        StUrl.prototype.init = function() {};
        return StUrl;
    }();
    exports.StUrl = StUrl;
});

define("general-methods/notification", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.STNotification = void 0;
    var STNotification = function() {
        function STNotification() {
            var _this = this;
            this.className = "STNotification";
            this.init = function(message, error) {
                var notificationMessage = document.querySelector(".st_notification");
                if (!!notificationMessage && message && message != "") {
                    _this.showMessage(notificationMessage, message, error);
                    clearTimeout(_this.globalTimeOut);
                    _this.globalTimeOut = setTimeout(function() {
                        console.log("TIMEOUT");
                        notificationMessage.classList.remove("st_show");
                        notificationMessage.classList.add("st_hidden");
                    }, 3e3);
                }
            };
            this.showMessage = function(notificationMessage, message, error) {
                notificationMessage.classList.remove("st_hidden");
                notificationMessage.innerHTML = message;
                if (error) {
                    notificationMessage.style.background = "#f82c3b";
                } else {
                    notificationMessage.style.background = "#059862";
                }
                console.log("SHOW");
                notificationMessage.classList.add("st_show");
            };
        }
        Object.defineProperty(STNotification, "Instance", {
            get: function() {
                return this._instance || (this._instance = new this());
            },
            enumerable: false,
            configurable: true
        });
        return STNotification;
    }();
    exports.STNotification = STNotification;
});

define("users/rep-info", [ "require", "exports", "static/static", "general-methods/ajax" ], function(require, exports, static_5, ajax_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StRepInfo = void 0;
    var StRepInfo = function() {
        function StRepInfo() {
            this.className = "RepInfo";
            this.init = function() {};
            this.static = static_5.StStatic.Instance;
            this.endpoint = this.static.obtainStaticEndpoints();
            this.endpointString = this.endpoint["rep-info"];
            this.ajax = ajax_4.StAjax.Instance;
            this.init();
        }
        Object.defineProperty(StRepInfo, "Instance", {
            get: function() {
                return this._instance || (this._instance = new this());
            },
            enumerable: false,
            configurable: true
        });
        StRepInfo.prototype.getRepInfoAjax = function(webAlias) {
            var _this = this;
            var requestData = {
                als: webAlias,
                returnCancelledOverride: true
            };
            this.ajax.send({
                endpoint: this.endpointString,
                method: "POST",
                contentType: "json",
                data: requestData,
                callback: function(res, req, name) {
                    var repInfo = JSON.parse(res.response).data;
                    _this.injectRepInfoPicture(repInfo);
                    _this.injectRepInfoPhone(repInfo);
                    _this.injectRepInfoEmail(repInfo);
                }
            });
        };
        StRepInfo.prototype.injectRepInfoPicture = function(repInfo) {
            var repPictures = document.querySelectorAll(".st_rep-info-picture_JS");
            if (repPictures.length > 0) {
                var pictureSrc = repInfo.PublicImageUrl ? "https://extranet.bydesign.com/NewULife/Personal/PersonalImages/".concat(repInfo.PublicImageUrl) : "https://cdn.shopify.com/s/files/1/0643/6359/3944/files/default.webp?v=1690449140";
                for (var i = 0; i < repPictures.length; i++) {
                    repPictures[i].src = pictureSrc;
                }
            }
        };
        StRepInfo.prototype.injectRepInfoPhone = function(repInfo) {
            var phoneNumber = "";
            if (!!repInfo.Phone1) {
                phoneNumber = !!repInfo.Phone1 ? repInfo.Phone1 : "";
            } else if (!!repInfo.Phone2) {
                phoneNumber = !!repInfo.Phone2 ? repInfo.Phone2 : "";
            } else if (!!repInfo.Phone3) {
                phoneNumber = !!repInfo.Phone3 ? repInfo.Phone3 : "";
            } else if (!!repInfo.Phone4) {
                phoneNumber = !!repInfo.Phone4 ? repInfo.Phone4 : "";
            }
            var repPhone = document.querySelectorAll(".st_rep-info-phone_JS");
            var repPhoneDiv = document.querySelectorAll(".st_rep-info-phone-div_JS");
            if (phoneNumber === "") {
                if (repPhoneDiv.length > 0) {
                    for (var i = 0; i < repPhoneDiv.length; i++) {
                        repPhoneDiv[i].remove();
                    }
                }
            } else {
                if (repPhone.length > 0) {
                    for (var i = 0; i < repPhone.length; i++) {
                        repPhoneDiv[i].style.display = "block";
                        repPhone[i].innerText = phoneNumber;
                        if (phoneNumber !== "") repPhone[i].href = "tel:".concat(phoneNumber);
                    }
                }
            }
        };
        StRepInfo.prototype.injectRepInfoEmail = function(repInfo) {
            var repEmail = document.querySelectorAll(".st_rep-info-email_JS");
            var repEmailDiv = document.querySelectorAll(".st_rep-info-email-div_JS");
            var email = !!repInfo.Email ? repInfo.Email : "";
            if (email === "") {
                if (repEmailDiv.length > 0) {
                    for (var i = 0; i < repEmailDiv.length; i++) {
                        repEmailDiv[i].remove();
                    }
                }
            } else {
                if (repEmail.length > 0) {
                    for (var i = 0; i < repEmail.length; i++) {
                        repEmailDiv[i].style.display = "block";
                        repEmail[i].innerText = email;
                        if (email !== "") repEmail[i].href = "mailto:".concat(email);
                    }
                }
            }
        };
        return StRepInfo;
    }();
    exports.StRepInfo = StRepInfo;
});

define("webalias/webalias", [ "require", "exports", "general-methods/general-methods", "general-methods/ajax", "general-methods/object-formatting", "static/static", "general-methods/url", "users/rep-info" ], function(require, exports, general_methods_2, ajax_5, object_formatting_2, static_6, url_1, rep_info_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StWebAlias = void 0;
    var ECustomerType;
    (function(ECustomerType) {
        ECustomerType["representative"] = "representative";
        ECustomerType["retail"] = "retail";
        ECustomerType["guest"] = "guest";
    })(ECustomerType || (ECustomerType = {}));
    var StWebAlias = function() {
        function StWebAlias() {
            var _this_1 = this;
            this.className = "WebAlias";
            this.repAliasCSSSelector = ".nul_representative-alias_JS";
            this.repFullNameCSSSelector = ".nul_representative-fullname_JS";
            this.repSiteCSSSelector = ".nul_representative-site_JS";
            this.sessionAlias = {
                getAlias: function() {
                    return !!window.sessionStorage.getItem("als") ? window.sessionStorage.getItem("als") : _this_1.static.defaultAlias;
                },
                setAlias: function(alias) {
                    window.sessionStorage.setItem("als", alias);
                }
            };
            this.init = function() {
                var _this = _this_1;
                _this_1.generalMethods.subscribeDOMLoaded(function() {
                    _this.checkWebAlias();
                    _this.copyingPasswordValueInHiddenInput();
                });
            };
            this.checkWebAlias = function() {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var alias = urlParams.als;
                if (typeof alias === "undefined") {
                    alias = _this_1.sessionAlias.getAlias();
                }
                var _this = _this_1;
                var customerInfoMetafields = window.customerInfoMetafields;
                var newAlias;
                switch (customerInfoMetafields.customerType) {
                  case ECustomerType.representative:
                    newAlias = customerInfoMetafields.customerId;
                    _this.aliasValidation(newAlias, ECustomerType.representative);
                    break;

                  case ECustomerType.retail:
                    _this.getRepID(customerInfoMetafields.customerId, _this.aliasValidation);
                    break;

                  default:
                    newAlias = !!alias ? alias : _this.sessionAlias.getAlias();
                    _this.aliasValidation(newAlias, ECustomerType.guest);
                    break;
                }
            };
            this.getRepID = function(retailID, cb, callbackParams) {
                if (cb === void 0) {
                    cb = function() {};
                }
                if (callbackParams === void 0) {
                    callbackParams = [];
                }
                var _this = _this_1;
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["retail-account-info"],
                    method: "post",
                    contentType: "json",
                    data: {
                        accountID: retailID
                    },
                    callback: function(response) {
                        try {
                            var repIDResponse = JSON.parse(response.response);
                            if (repIDResponse.status === 200) {
                                cb(repIDResponse.data.repID, ECustomerType.retail);
                            } else {
                                cb(_this.static.defaultAlias, ECustomerType.retail);
                            }
                        } catch (err) {
                            cb(_this.static.defaultAlias, ECustomerType.retail);
                        }
                    }
                });
            };
            this.aliasValidation = function(newAlias, customerType) {
                var _this = _this_1;
                var repInfo = {
                    als: _this.static.defaultAlias,
                    firstName: "",
                    lastName: "",
                    sponsorRepDID: "",
                    sponsorFirstName: "",
                    sponsorLastName: ""
                };
                if (newAlias !== _this.static.defaultAlias) {
                    _this_1.ajax.send({
                        endpoint: _this_1.endpoint["get-rep-site-info"],
                        method: "post",
                        contentType: "json",
                        data: {
                            als: newAlias
                        },
                        callback: function(response) {
                            try {
                                var repInfoResponse = JSON.parse(response.response);
                                console.log("repInfoResponse", repInfoResponse);
                                var repInformation = repInfoResponse.data;
                                if (repInfoResponse.status === 200) {
                                    repInfo.als = repInformation.repID;
                                    repInfo.firstName = repInformation.firstName;
                                    repInfo.lastName = repInformation.lastName;
                                    repInfo.company = repInformation === null || repInformation === void 0 ? void 0 : repInformation.company;
                                    if (customerType === ECustomerType.representative) {
                                        repInfo.sponsorFirstName = !!repInformation.sponsorFirstName ? repInformation.sponsorFirstName : undefined;
                                        repInfo.sponsorLastName = !!repInformation.sponsorLastName ? repInformation.sponsorLastName : undefined;
                                        repInfo.sponsorRepDID = !!repInformation.sponsorRepDID ? repInformation.sponsorRepDID : undefined;
                                    }
                                    _this.updateCurrentRepSite(repInfo);
                                } else {
                                    _this.updateCurrentRepSite(repInfo);
                                }
                            } catch (err) {
                                _this.updateCurrentRepSite(repInfo);
                            }
                        }
                    });
                } else {
                    _this.updateCurrentRepSite(repInfo);
                }
            };
            this.updateCurrentRepSite = function(repInfo) {
                _this_1.repInfo.getRepInfoAjax(repInfo.als);
                _this_1.sessionAlias.setAlias(repInfo.als);
                _this_1.updateUrl(repInfo.als);
                _this_1.appendAlsToField(repInfo.als);
                _this_1.appendRepFullNameToField(repInfo);
                _this_1.appendRepSiteToField(repInfo.als, repInfo.sponsorRepDID);
            };
            this.updateCurrentRepSiteOnRepChosen = function(repInfo) {
                _this_1.sessionAlias.setAlias(repInfo.als);
                _this_1.updateUrl(repInfo.als);
            };
            this.hasMetafieldsRep = function() {
                var _a;
                return ((_a = window.customerTags) === null || _a === void 0 ? void 0 : _a.includes("representative")) && window.repID !== "";
            };
            this.removeRepIncorrectData = function(repInfo) {
                Object.keys(repInfo).forEach(function(key) {
                    if (key !== "firstName") {
                        repInfo[key] = "";
                    }
                });
                repInfo.als = _this_1.static.defaultAlias;
                return repInfo;
            };
            this.updateUrl = function(newAlias) {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                urlParams.als = newAlias;
                var newURL = window.location.href.replace(window.location.search, "");
                _this_1.url.browserHistoryPush(newURL, urlParams);
            };
            this.appendAlsToField = function(alias) {
                var repAliasFields = document.querySelectorAll(_this_1.repAliasCSSSelector);
                if (repAliasFields.length > 0) {
                    for (var i = 0; i < repAliasFields.length; i++) {
                        if (repAliasFields[i].tagName.toLowerCase() === "input") {
                            repAliasFields[i].value = alias;
                        } else {
                            repAliasFields[i].innerHTML = alias;
                        }
                    }
                }
            };
            this.appendRepSiteToField = function(alias, sponsorAlias) {
                var userType = !!window.customerTags ? window.customerTags.includes("customer") : false;
                var repSiteCSSSelector = document.querySelectorAll(_this_1.repSiteCSSSelector);
                var repSite = "https://".concat(alias, ".newulife.com");
                if (repSiteCSSSelector.length > 0) {
                    for (var i = 0; i < repSiteCSSSelector.length; i++) {
                        if (repSiteCSSSelector[i].tagName.toLowerCase() === "input") {
                            repSiteCSSSelector[i].value = repSite;
                        } else if (repSiteCSSSelector[i].tagName.toLowerCase() === "a") {
                            if (!!sponsorAlias && !userType) {
                                repSiteCSSSelector[i].setAttribute("href", "https://".concat(sponsorAlias, ".newulife.com"));
                            } else {
                                repSiteCSSSelector[i].setAttribute("href", repSite);
                            }
                        } else {
                            repSiteCSSSelector[i].innerHTML = repSite;
                        }
                    }
                }
            };
            this.appendRepFullNameToField = function(repInfo) {
                var repFullNameFields = document.querySelectorAll(_this_1.repFullNameCSSSelector);
                repFullNameFields.forEach(function(field) {
                    if (repInfo.als !== _this_1.static.defaultAlias) {
                        if (!!repInfo.company) {
                            field.innerHTML = repInfo.company;
                        } else if (!!repInfo.firstName && !!repInfo.lastName) {
                            field.innerHTML = repInfo.firstName + " " + repInfo.lastName;
                        }
                    } else {
                        field.innerHTML = _this_1.static.companyName;
                    }
                });
            };
            this.copyingPasswordValueInHiddenInput = function() {
                var passInput = document.querySelector(".nul_register-pass-input_JS");
                var hiddenPassInput = document.querySelector(".nul_register-pass-hidden-input_JS");
                if (!!passInput) {
                    passInput.addEventListener("input", function() {
                        hiddenPassInput.value = passInput.value;
                    });
                }
            };
            this.getCustomerID = function() {
                var announcementBar = document.querySelector(".nul_announcement-bar-country_JS");
                if (!!announcementBar) {
                    var customerId = announcementBar.getAttribute("data-customer-id");
                    return !!customerId && customerId !== "" ? customerId : "";
                }
            };
            this.generalMethods = general_methods_2.StGeneralMethods.Instance;
            this.objectFormatting = object_formatting_2.StObjectFormatting.Instance;
            this.static = static_6.StStatic.Instance;
            this.endpoint = this.static.obtainStaticEndpoints();
            this.ajax = ajax_5.StAjax.Instance;
            this.url = url_1.StUrl.Instance;
            this.repInfo = rep_info_1.StRepInfo.Instance;
            this.init();
        }
        Object.defineProperty(StWebAlias, "Instance", {
            get: function() {
                return this._instance || (this._instance = new this());
            },
            enumerable: false,
            configurable: true
        });
        return StWebAlias;
    }();
    exports.StWebAlias = StWebAlias;
});

define("users/find-rep", [ "require", "exports", "general-methods/ajax", "general-methods/general-methods", "general-methods/object-formatting", "static/static", "webalias/webalias" ], function(require, exports, ajax_6, general_methods_3, object_formatting_3, static_7, webalias_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StFindRep = void 0;
    var StFindRep = function() {
        function StFindRep() {
            var _this_1 = this;
            this.className = "FindRep";
            this.MIN_CHAR_SEARCH_REQUIREMENT = 2;
            this.SEARCH_REQ_DELAY = 1e3;
            this.sessionAlias = {
                getAlias: function() {
                    return !!window.sessionStorage.getItem("als") ? window.sessionStorage.getItem("als") : _this_1.static.defaultAlias;
                }
            };
            this.init = function() {
                var _this = _this_1;
                _this_1.generalMethods.subscribeDOMLoaded(function() {
                    var searchRepModal = document.querySelector(".st_find-rep--modal_JS");
                    var searchRepBtn = document.querySelector(".st_find-rep--search-button_JS");
                    var closeModalBtnList = document.querySelectorAll(".st_modal-close-btn_JS");
                    if (!!searchRepBtn) {
                        _this.initSearchBoxFunctionality();
                        _this.initRadioButtons();
                        searchRepBtn.onclick = function() {
                            _this.modalOn(searchRepModal);
                        };
                    }
                    if (closeModalBtnList.length > 0) {
                        closeModalBtnList.forEach(function(closeBtn) {
                            closeBtn.onclick = function(e) {
                                _this.modalOff(searchRepModal);
                                _this.resetSearchBoxResults(".st-autocom-box_JS", true, ".st-search_JS");
                                _this.toggleSelectedRep(false);
                            };
                        });
                    }
                });
            };
            this.windowModalsClose = function(event) {
                var searchRepModal = document.querySelector(".st_find-rep--modal_JS");
                if (event.target == searchRepModal) {
                    _this_1.modalOff(searchRepModal);
                    _this_1.resetSearchBoxResults(".st-autocom-box_JS", true, ".st-search_JS");
                    _this_1.toggleSelectedRep(false);
                }
            };
            this.generalMethods = general_methods_3.StGeneralMethods.Instance;
            this.objectFormatting = object_formatting_3.StObjectFormatting.Instance;
            this.static = static_7.StStatic.Instance;
            this.endpoint = this.static.obtainStaticEndpoints();
            this.endpointString = this.endpoint["search-rep-id"];
            this.ajax = ajax_6.StAjax.Instance;
            this.webAlias = webalias_1.StWebAlias.Instance;
            this.init();
        }
        Object.defineProperty(StFindRep, "Instance", {
            get: function() {
                return this._instance || (this._instance = new this());
            },
            enumerable: false,
            configurable: true
        });
        StFindRep.prototype.initRadioButtons = function() {
            var _this = this;
            var connectRepRadio = document.querySelector(".st_connect-rep-radio_JS");
            var noRepRadio = document.querySelector(".st_no-rep-radio_JS");
            var idRadioLabel = document.querySelector(".st_id-radio-label_JS");
            var personaInfoRadioLabel = document.querySelector(".st_personal-info-radio-label_JS");
            if (!!connectRepRadio && !connectRepRadio.checked) {
                connectRepRadio.checked = true;
            }
            connectRepRadio.onchange = function(e) {
                if (connectRepRadio.checked) {
                    _this.endpointString = _this.endpoint["search-rep-id"];
                    _this.resetSearchBoxResults(".st-autocom-box_JS", true, ".st-search_JS");
                    _this.changeSearchDescriptionText("Enter ID or web alias of the distributor you are looking for.");
                    idRadioLabel.classList.add("st_radio-label-active");
                    personaInfoRadioLabel.classList.remove("st_radio-label-active");
                }
            };
            noRepRadio.onchange = function(e) {
                if (noRepRadio.checked) {
                    _this.endpointString = _this.endpoint["search-rep-info"];
                    _this.resetSearchBoxResults(".st-autocom-box_JS", true, ".st-search_JS");
                    _this.changeSearchDescriptionText("Enter Name, State or province of the distributor you are looking for.");
                    idRadioLabel.classList.remove("st_radio-label-active");
                    personaInfoRadioLabel.classList.add("st_radio-label-active");
                }
            };
        };
        StFindRep.prototype.initSearchBoxFunctionality = function() {
            var _this_1 = this;
            var _this = this;
            var searchWrapper = document.querySelector(".st-search-wrapper_JS");
            var inputBox = searchWrapper.querySelector(".st-search_JS");
            var suggestionBox = searchWrapper.querySelector(".st-autocom-box_JS");
            var loader = searchWrapper.querySelector(".st-loader_JS");
            var searchIcon = searchWrapper.querySelector(".st-svg-icon_JS");
            var requestTimeout;
            inputBox.onkeyup = function(e) {
                if (inputBox.value[0] === " ") {
                    e.preventDefault();
                } else {
                    clearTimeout(requestTimeout);
                    requestTimeout = setTimeout(sendRequest, _this.SEARCH_REQ_DELAY);
                }
            };
            var sendRequest = function() {
                if (inputBox.value.length >= _this_1.MIN_CHAR_SEARCH_REQUIREMENT) {
                    _this_1.hideSearchIcon(searchIcon);
                    _this_1.searchLoaderOn(loader);
                    var requestData = {
                        query: inputBox.value
                    };
                    _this_1.ajax.send({
                        endpoint: _this_1.endpointString,
                        method: "POST",
                        contentType: "json",
                        data: requestData,
                        callback: function(res, req, name) {
                            res = JSON.parse(res.response);
                            var repList = res.data.representatives;
                            if (repList !== undefined) {
                                if (repList.length > 0) {
                                    _this.showSuggestions(repList, suggestionBox, inputBox.value);
                                } else {
                                    _this.showNoResults(suggestionBox);
                                }
                            } else {
                                _this.showNoResults(suggestionBox);
                            }
                            _this.searchAutocomBoxActive(searchWrapper);
                            _this.searchLoaderOff(loader);
                            _this.showSearchIcon(searchIcon);
                        }
                    });
                } else {
                    _this_1.resetSearchBoxResults(".st-autocom-box_JS", true, ".st-search_JS");
                    _this_1.searchAutocomBoxInactive(searchWrapper);
                }
            };
            this.turnOffSuggBoxWhenClickedOutside(".st_find-rep--modal-content_JS");
        };
        StFindRep.prototype.turnOffSuggBoxWhenClickedOutside = function(turnOffTarget) {
            var _this = this;
            var searchRepModal = document.querySelector(turnOffTarget);
            var inputBox = document.querySelector(".st-search_JS");
            var suggestionBox = document.querySelector(".st-autocom-box_JS");
            searchRepModal.onclick = function(e) {
                if (e.target == searchRepModal && e.target !== inputBox && e.target !== suggestionBox) {
                    _this.resetSearchBoxResults(".st-autocom-box_JS", false);
                }
            };
        };
        StFindRep.prototype.initSelectButton = function(representative) {
            var _this_1 = this;
            var selectButton = document.querySelector(".st_find-rep--selected-btn_JS");
            if (!!selectButton) {
                selectButton.onclick = function() {
                    _this_1.addSelectButtonOnClickEvent(representative);
                };
            }
        };
        StFindRep.prototype.addSelectButtonOnClickEvent = function(representative) {
            console.log("representative", representative);
            var searchRepModal = document.querySelector(".st_find-rep--modal_JS");
            var invisibleCartTextArea = document.querySelector(".st_hidden-cart-notes-input_JS");
            var shoppingWithRepData = document.querySelector(".st_shopping-with-rep-data_JS");
            shoppingWithRepData.innerHTML = "".concat(representative.displayName, ", ").concat(representative.repDID, " | ").concat(representative.city, ", ").concat(representative.state);
            invisibleCartTextArea.value = representative.webAlias;
            var displayNameSplit = representative.displayName.split(" ");
            this.webAlias.updateCurrentRepSite({
                als: representative.webAlias,
                firstName: displayNameSplit[0],
                lastName: displayNameSplit[1],
                sponsorRepDID: representative.repDID
            });
            this.modalOff(searchRepModal);
            this.resetSearchBoxResults(".st-autocom-box_JS", true, ".st-search_JS");
            this.toggleSelectedRep(false);
        };
        StFindRep.prototype.clearSelectButtonOnClickEvent = function(representative) {
            var _this_1 = this;
            var selectButton = document.querySelector(".st_find-rep--selected-btn_JS");
            selectButton.removeEventListener("click", function() {
                _this_1.addSelectButtonOnClickEvent(representative);
            });
        };
        StFindRep.prototype.showSuggestions = function(repsList, suggestionBox, searchQuery) {
            if (repsList.length > 0) {
                this.resetSearchBoxResults(".st-autocom-box_JS", false);
                var _this_3 = this;
                repsList.forEach(function(rep) {
                    var regEx = new RegExp(searchQuery, "ig");
                    var displayNameMatches = rep.displayName.match(regEx);
                    var cityAndStateMatches = "".concat(rep.city, ", ").concat(rep.state).match(regEx);
                    var webAliasMatch = rep.webAlias === searchQuery ? rep.webAlias : "";
                    var allMatches = [].concat(displayNameMatches, cityAndStateMatches).filter(function(value, index, self) {
                        return self.indexOf(value) === index;
                    });
                    var finalDisplayName = rep.displayName;
                    var finalCityAndState = "".concat(rep.city, ", ").concat(rep.state);
                    allMatches.forEach(function(match) {
                        finalDisplayName = finalDisplayName.replaceAll(match, '<span class="st_matched_text">'.concat(match, "</span>"));
                        finalCityAndState = finalCityAndState.replaceAll(match, '<span class="st_matched_text">'.concat(match, "</span>"));
                    });
                    var liElement = document.createElement("li");
                    liElement.innerHTML = "<div>\n                 <p>\n                 ".concat(finalDisplayName, ', <span class="st_autocom-box--id">\n                 ').concat(rep.repDID ? rep.repDID.replaceAll(regEx, '<span class="st_matched_text">'.concat(searchQuery, "</span>")) : "", "\n                    ").concat(webAliasMatch.length > 0 ? rep.webAlias.replaceAll(regEx, ', <span class="st_matched_text">'.concat(searchQuery, "</span>")) : "", ' \n                    </span>\n                 </p>\n                 <p class="st_autocom-box--state-info">\n                 ').concat(finalCityAndState, "\n                 </p>\n                </div>");
                    liElement.onclick = function(e) {
                        _this_3.selectRepresentative(rep);
                        _this_3.toggleSelectedRep(true);
                    };
                    suggestionBox.appendChild(liElement);
                });
            }
        };
        StFindRep.prototype.showNoResults = function(suggestionBox) {
            this.resetSearchBoxResults(".st-autocom-box_JS", false);
            var noResultsParagraph = document.createElement("p");
            noResultsParagraph.innerText = "No distributors found";
            suggestionBox.appendChild(noResultsParagraph);
        };
        StFindRep.prototype.selectRepresentative = function(representative) {
            var _this = this;
            var repName = document.querySelector(".st_find-rep--selected-info_JS");
            var repState = document.querySelector(".st_find-rep--selected-state_JS");
            var repID = document.querySelector(".st_find-rep--selected-id_JS");
            var backToSelectAnchor = document.querySelector(".st_find-rep--back-anchor_JS");
            var searchRepModal = document.querySelector(".st_find-rep--modal_JS");
            this.initSelectButton(representative);
            backToSelectAnchor.onclick = function(e) {
                _this.clearSelectButtonOnClickEvent(representative);
                _this.resetSearchBoxResults(".st-autocom-box_JS", true, ".st-search_JS");
                _this.toggleSelectedRep(false);
            };
            repName.innerText = representative.displayName;
            repState.innerText = "".concat(representative.city, ", ").concat(representative.state);
            repID.innerText = "ID ".concat(representative.repDID);
        };
        StFindRep.prototype.resetSearchBoxResults = function(suggestionBoxToReset, resetSearchValue, searchInputField) {
            var loader = document.querySelector(".st-loader_JS");
            var searchSuggestionBox = document.querySelector(suggestionBoxToReset);
            if (!!searchSuggestionBox) {
                searchSuggestionBox.innerHTML = "";
                if (resetSearchValue && searchInputField) {
                    var inputBox = document.querySelector(searchInputField);
                    if (!!inputBox) {
                        inputBox.value = "";
                    }
                    if (!!loader) {
                        this.searchLoaderOff(loader);
                    }
                }
            }
        };
        StFindRep.prototype.searchAutocomBoxActive = function(searchWrapper) {
            searchWrapper.classList.add("st-active");
        };
        StFindRep.prototype.searchAutocomBoxInactive = function(searchWrapper) {
            searchWrapper.classList.remove("st-active");
        };
        StFindRep.prototype.searchLoaderOn = function(loader) {
            loader.style.display = "inline-block";
        };
        StFindRep.prototype.searchLoaderOff = function(loader) {
            loader.style.display = "none";
        };
        StFindRep.prototype.showSearchIcon = function(searchIcon) {
            searchIcon.style.display = "inline";
        };
        StFindRep.prototype.hideSearchIcon = function(searchIcon) {
            searchIcon.style.display = "none";
        };
        StFindRep.prototype.modalOn = function(searchRepModal) {
            searchRepModal.classList.remove("st_modal-close");
            searchRepModal.classList.add("st_modal-open");
            searchRepModal.classList.add("st_prevent-drawer-close");
        };
        StFindRep.prototype.modalOff = function(searchRepModal) {
            searchRepModal.classList.remove("st_modal-open");
            searchRepModal.classList.add("st_modal-close");
        };
        StFindRep.prototype.changeSearchDescriptionText = function(desc) {
            var descParagraph = document.querySelector(".st_search-desc_JS");
            if (!!descParagraph) {
                descParagraph.innerHTML = desc;
            }
        };
        StFindRep.prototype.hideSearchBox = function() {
            var searchBox = document.querySelector(".st-search-wrapper_JS");
            searchBox.style.display = "none";
            searchBox.style.pointerEvents = "none";
            this.resetSearchBoxResults(".st-autocom-box_JS", true, ".st-search_JS");
        };
        StFindRep.prototype.showSearchBox = function() {
            var searchBox = document.querySelector(".st-search-wrapper_JS");
            searchBox.style.display = "block";
            searchBox.style.pointerEvents = "auto";
        };
        StFindRep.prototype.clearBackToSelectEventListener = function(anchorToClick) {
            var _this = this;
            anchorToClick.removeEventListener("click", function(e) {
                _this.resetSearchBoxResults(".st-autocom-box_JS", true, ".st-search_JS");
                _this.toggleSelectedRep(false);
            });
        };
        StFindRep.prototype.clearModalEventListenerForSuggBox = function() {
            var _this = this;
            var searchRepModal = document.querySelector(".st_find-rep--modal-content_JS");
            var inputBox = document.querySelector(".st-search_JS");
            var suggestionBox = document.querySelector(".st-autocom-box_JS");
            searchRepModal.removeEventListener("click", function(e) {
                if (e.target == searchRepModal && e.target !== inputBox && e.target !== suggestionBox) {
                    _this.resetSearchBoxResults(".st-autocom-box_JS", false);
                }
            });
        };
        StFindRep.prototype.toggleSelectedRep = function(selectedRepOn) {
            var modalContent = document.querySelector(".st_find-rep--modal-content_JS");
            var selectedRepContent = document.querySelector(".st_find-rep--modal-selected-rep_JS");
            var backToSelectAnchor = document.querySelector(".st_find-rep--back-anchor_JS");
            if (selectedRepOn) {
                modalContent.style.display = "none";
                modalContent.style.pointerEvents = "none";
                selectedRepContent.style.display = "block";
                selectedRepContent.style.pointerEvents = "auto";
            } else {
                this.clearBackToSelectEventListener(backToSelectAnchor);
                selectedRepContent.style.display = "none";
                selectedRepContent.style.pointerEvents = "none";
                modalContent.style.display = "block";
                modalContent.style.pointerEvents = "auto";
            }
        };
        Object.defineProperty(StFindRep.prototype, "getCurrentAlias", {
            get: function() {
                var urlQueryParams = this.objectFormatting.convertQueryStringToObject(window.location.search);
                if (!!urlQueryParams.als) {
                    return urlQueryParams.als;
                } else return false;
            },
            enumerable: false,
            configurable: true
        });
        return StFindRep;
    }();
    exports.StFindRep = StFindRep;
});

define("users/shopping-on-behalf", [ "require", "exports", "general-methods/general-methods", "general-methods/ajax", "general-methods/object-formatting", "static/static", "general-methods/url", "general-methods/notification" ], function(require, exports, general_methods_4, ajax_7, object_formatting_4, static_8, url_2, notification_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StShoppingOnBehalf = void 0;
    var StShoppingOnBehalf = function() {
        function StShoppingOnBehalf() {
            var _this_1 = this;
            this.className = "ShoppingOnBehalf";
            this.SHOB_ID_TAG_PREFIX = "shob_id:";
            this.SHOB_RETAIL = "shopping_on_behalf_r";
            this.SHOB_WHOLESALE = "shopping_on_behalf_w";
            this.init = function() {
                var _this = _this_1;
                _this_1.generalMethods.subscribeDOMLoaded(function() {
                    _this.initRadioButtons();
                    var shoppingOnBehalfBar = document.querySelector(".st_shopping-behalf-bar_JS");
                    if (!!shoppingOnBehalfBar) {
                        var logoutBtn = document.querySelector(".st_shopping-behalf-logout-btn_JS");
                        logoutBtn.onclick = function() {
                            _this.logOut();
                        };
                        _this.getShoppingOnBehalfInfo();
                    }
                });
            };
            this.logOut = function() {
                window.location.replace(window.location.origin + "/account/logout");
            };
            this.getShoppingOnBehalfInfo = function() {
                var _this = _this_1;
                var shoppingOnBehalfType;
                var shoppingOnBehalfTag = window.customerTags.filter(function(tag) {
                    return tag.includes(_this_1.SHOB_ID_TAG_PREFIX);
                });
                var shoppingOnBehalfW = window.customerTags.filter(function(tag) {
                    return tag.includes(_this_1.SHOB_WHOLESALE);
                });
                var shoppingOnBehalfR = window.customerTags.filter(function(tag) {
                    return tag.includes(_this_1.SHOB_RETAIL);
                });
                if (shoppingOnBehalfR) {
                    shoppingOnBehalfType = shoppingOnBehalfR[0];
                } else if (shoppingOnBehalfW) {
                    shoppingOnBehalfType = shoppingOnBehalfW[0];
                }
                var shoppingOnBehalfID = shoppingOnBehalfTag[0].slice(shoppingOnBehalfTag[0].indexOf(_this_1.SHOB_ID_TAG_PREFIX) + _this_1.SHOB_ID_TAG_PREFIX.length, shoppingOnBehalfTag[0].length);
                var requestData = {
                    byDesignID: shoppingOnBehalfID.trim(),
                    userType: shoppingOnBehalfType === _this_1.SHOB_RETAIL ? "customer" : "representative"
                };
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["shopping-on-behalf"],
                    method: "POST",
                    contentType: "json",
                    data: requestData,
                    callback: function(res, req, name) {
                        res = JSON.parse(res.response);
                        var sobInfo = res.data.shoppingOnBehalf;
                        _this.getSobCustomer(sobInfo.email);
                        var sobInfoParagraph = document.querySelector(".st_shopping-behalf--sob-info_JS");
                        var sobMarketAndDiscountParagraph = document.querySelector(".st_shopping-behalf--sob-market_JS");
                        sobInfoParagraph.innerHTML += "<b>".concat(sobInfo.sobDisplayName, ", ID ").concat(sobInfo.sobID, "</b>");
                        sobMarketAndDiscountParagraph.innerHTML = "Market is set to ".concat(_this.getCurrentMarket(), ", and the promotions and discount is set to ").concat(shoppingOnBehalfType === _this.SHOB_RETAIL ? '"Retail"' : '"Wholesale"');
                    }
                });
            };
            this.getSobCustomer = function(email) {
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["get-sob-customer"],
                    method: "POST",
                    contentType: "json",
                    data: {
                        email: email
                    },
                    callback: function(res, req, name) {
                        res = JSON.parse(res.response);
                        var sobInfo = res.data.representatives[0];
                        var email = sobInfo.email, defaultAddress = sobInfo.defaultAddress;
                        var firstName = defaultAddress.firstName, lastName = defaultAddress.lastName, address1 = defaultAddress.address1, address2 = defaultAddress.address2, city = defaultAddress.city, province = defaultAddress.province, country = defaultAddress.country, zip = defaultAddress.zip, phone = defaultAddress.phone, company = defaultAddress.company;
                        window.sobInfo = {
                            firstName: !!firstName ? firstName : "",
                            lastName: !!lastName ? lastName : "",
                            email: !!email ? email : "",
                            address1: !!address1 ? address1 : "",
                            address2: !!address2 ? address2 : "",
                            city: !!city ? city : "",
                            province: !!province ? province : "",
                            country: !!country ? country : "",
                            zip: !!zip ? zip : "",
                            phone: !!phone ? phone : "",
                            company: !!company ? company : ""
                        };
                    }
                });
            };
            this.getCurrentMarket = function() {
                var selectButton = document.querySelector(".nul_select-country_JS");
                var selectedOption = selectButton.selectedOptions[0].innerHTML;
                switch (selectedOption) {
                  case "Canada":
                    return "CA";

                  case "United States":
                    return "US";

                  default:
                    return "Error";
                }
            };
            this.initRadioButtons = function() {
                var prodVariants = document.querySelector(".st_product-variants-data_JS");
                var radioButtonWrappers = document.querySelectorAll(".st_shopping-on-behalf--radio-wrapper_JS");
                if (!!prodVariants) {
                    var prodId = prodVariants.innerHTML.trim();
                    if (prodId.includes("</a>")) {
                        prodId = prodId.slice(prodId.indexOf(">") + 1, prodId.lastIndexOf("<"));
                    }
                    _this_1.getVariantMeta(_this_1.handleGetVariantMetaResponse, prodId);
                }
                if (radioButtonWrappers.length > 0) {
                    radioButtonWrappers.forEach(function(radioBtnDiv) {
                        var radioBtn = radioBtnDiv.querySelector("input");
                        var radioBtnLabel = radioBtnDiv.querySelector("label");
                        if (radioBtn.checked) {
                            _this_1.renderVolumes(radioBtn.value);
                            radioBtnLabel.classList.add("st_radio-btn-colored-label");
                        }
                        radioBtn.onchange = function() {
                            if (radioBtn.checked) {
                                _this_1.renderVolumes(radioBtn.value);
                                radioBtnLabel.classList.add("st_radio-btn-colored-label");
                                radioButtonWrappers.forEach(function(sibling) {
                                    if (radioBtnDiv !== sibling) {
                                        var siblingLabel = sibling.querySelector("label");
                                        siblingLabel.classList.remove("st_radio-btn-colored-label");
                                    }
                                });
                            }
                        };
                    });
                }
            };
            this.getVariantMeta = function(handleFunc, productId) {
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["variant-meta"],
                    method: "POST",
                    contentType: "json",
                    data: {
                        productId: productId
                    },
                    callback: handleFunc
                });
            };
            this.handleGetVariantMetaResponse = function(res, req) {
                try {
                    res = JSON.parse(res.response);
                    var productVariants = res.data.productVariants;
                    if (!!productVariants) {
                        productVariants.forEach(function(variant) {
                            _this_1.variantVolumes.set(variant.title, {
                                qvolume: variant.qvolume,
                                cvolume: variant.cvolume
                            });
                        });
                    } else {
                        _this_1.notification.init("Error: Could not fetch variant data!", true);
                    }
                } catch (e) {
                    console.log(e);
                    _this_1.notification.init("Error: Could not fetch variant data!", true);
                }
            };
            this.renderVolumes = function(checkedValue) {
                if (_this_1.variantVolumes.has(checkedValue)) {
                    var qvSpan = document.querySelector(".st_qv-info_JS");
                    var cvSpan = document.querySelector(".st_cv-info_JS");
                    if (!!qvSpan && !!cvSpan) {
                        qvSpan.innerHTML = "QV: " + _this_1.variantVolumes.get(checkedValue).qvolume;
                        cvSpan.innerHTML = "CV: " + _this_1.variantVolumes.get(checkedValue).cvolume;
                    }
                }
            };
            this.generalMethods = general_methods_4.StGeneralMethods.Instance;
            this.objectFormatting = object_formatting_4.StObjectFormatting.Instance;
            this.static = static_8.StStatic.Instance;
            this.endpoint = this.static.obtainStaticEndpoints();
            this.ajax = ajax_7.StAjax.Instance;
            this.url = url_2.StUrl.Instance;
            this.notification = notification_1.STNotification.Instance;
            this.variantVolumes = new Map();
            this.init();
        }
        Object.defineProperty(StShoppingOnBehalf, "Instance", {
            get: function() {
                return this._instance || (this._instance = new this());
            },
            enumerable: false,
            configurable: true
        });
        return StShoppingOnBehalf;
    }();
    exports.StShoppingOnBehalf = StShoppingOnBehalf;
});

define("general-methods/form", [ "require", "exports", "static/static" ], function(require, exports, static_9) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StForm = void 0;
    var StForm = function() {
        function StForm() {
            this.collectFormData = function(form) {
                if (form === undefined || form === null) {
                    return false;
                }
                var data = {};
                for (var i = 0; i < form.elements.length; i++) {
                    var field = form.elements[i];
                    if (!field.name || field.type === "file" || field.type === "reset" || field.type === "submit" || field.type === "button") continue;
                    if (field.disabled && field.tagName !== "SELECT") continue;
                    if (field.type === "select-multiple") {
                        data[field.name] = [];
                        for (var n = 0; n < field.options.length; n++) {
                            if (!field.options[n].selected) continue;
                            data[field.name].push(field.options[n].value);
                        }
                    } else if (field.type !== "checkbox" && field.type !== "radio") {
                        data[field.name] = field.value;
                    } else if (field.type === "checkbox") {
                        data[field.name] = !!field.checked;
                    }
                }
                return data;
            };
            this.numbersOnly = function() {
                var numberInputs = document.querySelectorAll(".nuv_only-number_JS");
                if (numberInputs && numberInputs.length > 0) {
                    for (var i = 0; i < numberInputs.length; i++) {
                        var inputSelector = numberInputs[i];
                        inputSelector.addEventListener("keyup", function() {
                            this.value = isNaN(parseInt(this.value)) ? "" : parseInt(this.value);
                        });
                        inputSelector.addEventListener("input", function() {
                            this.value = isNaN(parseInt(this.value)) ? "" : parseInt(this.value);
                        });
                        inputSelector.addEventListener("change", function() {
                            this.value = isNaN(parseInt(this.value)) ? "" : parseInt(this.value);
                        });
                    }
                }
            };
            this.formValidation = function() {
                var taxId = document.querySelector('[name="enrollment[tax_id]"]');
                if (taxId && typeof taxId != "undefined") {
                    taxId.addEventListener("input", function(e) {
                        this.applyFormatting(this);
                    });
                }
                var email = document.querySelector('[name="enrollment[email]"]');
                if (email && typeof email != "undefined") {
                    email.addEventListener("input", function(e) {
                        this.validateEmail(this);
                    });
                }
                var upgradeEmail = document.querySelector('[name="address[email]"]');
                if (upgradeEmail && typeof upgradeEmail != "undefined") {
                    upgradeEmail.addEventListener("input", function(e) {
                        this.validateEmail(this);
                    });
                }
            };
            this.validateDateOfBirth = function() {
                var currentYear = new Date().getFullYear();
                var dateOfBirtd = document.querySelector('[name="enrollment[date_of_birtd]"]');
                if (dateOfBirtd && typeof dateOfBirtd != "undefined") {
                    var date = new Date(dateOfBirtd.value);
                    var year = date.getFullYear();
                    if (year < currentYear && year > 1900) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            };
            this.validateEmail = function(field) {
                var valid = false;
                var val = field.value;
                var at = val.indexOf("@");
                if (at >= 2) {
                    val = val.substr(at);
                    var dot = val.indexOf(".");
                    if (dot >= 2) {
                        val = val.substr(dot);
                        if (val.length >= 2) {
                            valid = true;
                            if (field.classList.contains("st-bds_invalid_input")) {
                                field.classList.remove("st-bds_invalid_input");
                            }
                        }
                    } else {
                        if (!field.classList.contains("st-bds_invalid_input")) {
                            field.classList.add("st-bds_invalid_input");
                        }
                    }
                } else {
                    if (!field.classList.contains("st-bds_invalid_input")) {
                        field.classList.add("st-bds_invalid_input");
                    }
                }
                return valid;
            };
            this.applyFormatting = function(field) {
                var val = field.value;
                var format = "";
                var formatData = {
                    separator: "-",
                    format: "XXX-XX-XXXX",
                    type: "numeric"
                };
                if (formatData.type === "numeric") {
                    val = val.replace(/[^0-9]/g, "");
                }
                if (typeof formatData.format === "object") {
                    format = formatData.format[field.name];
                } else {
                    format = formatData.format;
                    var segments = formatData.separator ? formatData.format.split(formatData.separator) : [ formatData.format ];
                    var disp = [];
                    for (var i = 0; i < segments.length; i++) {
                        var it = val.substr(0, segments[i].length);
                        if (it !== "") {
                            disp.push(it);
                        }
                        val = val.replace(it, "");
                    }
                    val = disp.join(formatData.separator);
                }
                if (format.length > val.length) {
                    field.classList.add("st-bds_invalid_input");
                } else if (format.length === val.length) {
                    field.classList.remove("st-bds_invalid_input");
                } else {
                    val = val.substr(0, format.length);
                }
                field.value = val;
            };
            this.endpoint = static_9.StStatic.Instance.obtainStaticEndpoints();
        }
        Object.defineProperty(StForm, "Instance", {
            get: function() {
                return this._instance || (this._instance = new this());
            },
            enumerable: false,
            configurable: true
        });
        return StForm;
    }();
    exports.StForm = StForm;
});

define("users/account", [ "require", "exports", "general-methods/general-methods", "general-methods/object-formatting", "general-methods/url", "general-methods/ajax", "static/static", "general-methods/form", "general-methods/notification" ], function(require, exports, general_methods_5, object_formatting_5, url_3, ajax_8, static_10, form_1, notification_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccount = void 0;
    var EAccountPageTab;
    (function(EAccountPageTab) {
        EAccountPageTab["dashboard"] = "dashboard";
        EAccountPageTab["order_history"] = "order_history";
        EAccountPageTab["address_book"] = "address_book";
        EAccountPageTab["account_details"] = "account_details";
    })(EAccountPageTab || (EAccountPageTab = {}));
    var StAccount = function() {
        function StAccount() {
            var _this_1 = this;
            this.className = "Account";
            this.trimValueCSSSelector = ".nul_trim-value_JS";
            this.setPageCSSSelector = ".nul_set-page_JS";
            this.navButtonCSSSelector = ".nul_nav-button_JS";
            this.dashboardViewAllBtnCSSSelector = ".nul_dashboard-view-all-btn_JS";
            this.dashboardSidebarBtnCSSSelector = ".nul_dashboard-sidebar-btn_JS";
            this.dashboardContentCSSSelector = ".nul_account-dashboard-snippet-wrapper_JS";
            this.accountTabContentCSSSelector = ".nul_tabs-container_JS";
            this.backofficeBtnCSSSelector = ".nul_account-backoffice-login-btn_JS";
            this.autoshipBtnCSSSelector = ".nul_account-autoship-manager-btn_JS";
            this.loyaltyBtnCSSSelector = ".nul_account-loyalty-login-btn_JS";
            this.accountPageWrapperCSSSelector = ".nul_account-page-wrapper_JS";
            this.addressFormCSSSelector = ".nul_address-form_JS";
            this.addressMenuCSSSelector = ".nul_address-menu-btn_JS";
            this.accountSidebarCSSSelector = ".nul_account-sidebar_JS";
            this.init = function() {
                var _this = _this_1;
                _this_1.generalMethods.subscribeDOMLoaded(function() {
                    _this.sideBarHandler();
                    _this.openTab();
                    _this.dashboardViewAllOrders();
                    _this.paginationEvents();
                    _this.orderPaginationEvents();
                    _this.copyAffiliateLink();
                    _this.selectAffiliateLabel();
                    _this.subscribeActionsToButtons();
                    _this.disableBtnsAutoshipAndBackoffice();
                    _this.initAddressTab();
                    _this.reloadPageAfterLogoutMobile();
                });
            };
            this.initAddressTab = function() {
                _this_1.triggerAddressMenu();
                _this_1.addAddress();
                _this_1.openAddAddressForm();
                _this_1.closeForm();
            };
            this.orderPaginationEvents = function() {
                var nextPage = document.querySelectorAll(".nul_order-pagination_JS");
                var _this = _this_1;
                nextPage.forEach(function(btn) {
                    btn.addEventListener("click", function(e) {
                        e.preventDefault();
                        var page = this.getAttribute("data-pagination");
                        var section = _this.generalMethods.getClosestByClass(this, "shopify-section");
                        if (!!section) {
                            var sectionName_1 = _this.getSectionName(section);
                            _this.ajax.send({
                                endpoint: "".concat(window.location.protocol, "//").concat(window.location.hostname, "/?sections=").concat(sectionName_1, "&page=").concat(page),
                                method: "GET",
                                contentType: "json",
                                callback: function(res) {
                                    var sectionResponse = JSON.parse(res.response);
                                    var wrap = document.querySelector("#shopify-section-" + sectionName_1);
                                    if (!!wrap) {
                                        var parentEl = wrap.parentElement;
                                        wrap.remove();
                                        parentEl.innerHTML = sectionResponse[sectionName_1];
                                        _this.orderPaginationEvents();
                                    }
                                }
                            });
                        }
                    });
                });
            };
            this.liveTrimValue = function(container) {
                var _this = _this_1;
                if (!container) {
                    container = document;
                }
                var fields = container.querySelectorAll(_this.trimValueCSSSelector);
                fields.forEach(function(field) {
                    field.addEventListener("keyup", function() {
                        this.value = _this.trimValue(this.value);
                    });
                    field.addEventListener("input", function() {
                        this.value = _this.trimValue(this.value);
                    });
                    field.addEventListener("paste", function() {
                        this.value = _this.trimValue(this.value);
                    });
                });
            };
            this.trimValue = function(value) {
                return value.length == 1 ? value.replace(/\s/g, "") : value.replace(/\s\s+/g, " ");
            };
            this.getActiveTab = function() {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var tab = urlParams.tab.replace("-", "_");
                return tab;
            };
            this.againReloadFunction = function(activeSection) {
                if (!!activeSection) {
                    if (_this_1.getActiveTab() == EAccountPageTab.address_book) {
                        _this_1.initAddressTab();
                    }
                    return activeSection.querySelectorAll(_this_1.setPageCSSSelector);
                } else {
                    return document.querySelectorAll(_this_1.setPageCSSSelector);
                }
            };
            this.paginationEvents = function(activeSection) {
                var _this = _this_1;
                activeSection = !!activeSection ? activeSection : null;
                var nextPage = _this.againReloadFunction(activeSection);
                nextPage.forEach(function(btn) {
                    btn.addEventListener("click", function(e) {
                        e.preventDefault();
                        var page = this.getAttribute("data-set-page");
                        var section = _this.generalMethods.getClosestByClass(this, "shopify-section");
                        _this.getPage(page, section);
                    });
                });
            };
            this.getPage = function(page, section) {
                var _this = _this_1;
                if (!!section) {
                    var sectionName_2 = _this.getSectionName(section);
                    _this.ajax.send({
                        endpoint: window.location.protocol + "//" + window.location.hostname + "/?sections=" + sectionName_2 + "&page=" + page,
                        method: "GET",
                        contentType: "json",
                        callback: function(res) {
                            var sectionResponse = JSON.parse(res.response);
                            console.log(sectionResponse);
                            _this.appendContetForNewTab(sectionResponse, sectionName_2);
                        }
                    });
                }
            };
            this.getSectionName = function(section) {
                section = section.id;
                return section.replace("shopify-section-", "");
            };
            this.reloadPageAfterLogoutMobile = function() {
                var logoutListElement = document.querySelector(".nul_logout-btn-wrapper_JS");
                var mql = window.matchMedia("(max-width: 480px)");
                if (!!logoutListElement) {
                    if (mql.matches) {
                        logoutListElement.addEventListener("click", function() {
                            setTimeout(function() {
                                location.reload();
                            }, 500);
                        });
                    }
                }
            };
            this.appendContetForNewTab = function(sectionResponse, sectionName) {
                var wrap = document.querySelector("#shopify-section-" + sectionName);
                if (!!wrap) {
                    var parentEl = wrap.parentElement;
                    wrap.remove();
                    parentEl.innerHTML = sectionResponse[sectionName];
                    _this_1.paginationEvents(parentEl);
                }
            };
            this.openTab = function() {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                if (urlParams.tab) {
                    _this_1.setContainerClassSidebar(urlParams.tab);
                    _this_1.updateTabInUrl(urlParams.tab);
                    _this_1.hideAddressForms();
                    _this_1.triggerSidebarMenu(urlParams.tab);
                } else {
                    _this_1.updateTabInUrlDefault();
                }
            };
            this.updateTabInUrlDefault = function() {
                var defaultTab = document.querySelector(_this_1.dashboardSidebarBtnCSSSelector);
                if (!!defaultTab) {
                    var defaultPage = defaultTab.getAttribute("data-tab");
                    if (!!defaultPage) {
                        _this_1.updateTabInUrl(defaultPage);
                    }
                }
            };
            this.updateTabInUrl = function(activeTab) {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                urlParams.tab = activeTab;
                var serializedUrlParams = _this_1.objectFormatting.convertObjectToQueryString(urlParams);
                window.history.replaceState(urlParams, "", window.location.pathname + "?" + serializedUrlParams);
            };
            this.sideBarHandler = function() {
                var _this = _this_1;
                var tabsBtn = document.querySelectorAll(_this_1.navButtonCSSSelector);
                for (var i = 0; i < tabsBtn.length; i++) {
                    var tab = tabsBtn[i];
                    tab.addEventListener("click", function(e) {
                        e.preventDefault();
                        var activeTab = this.getAttribute("data-tab");
                        _this.setContainerClassSidebar(activeTab);
                        _this.updateTabInUrl(activeTab);
                        _this.hideAddressForms();
                        _this.triggerSidebarMenu(activeTab);
                    });
                }
            };
            this.setContainerClassSidebar = function(activeTab) {
                var accountTabContent = document.querySelectorAll(_this_1.accountTabContentCSSSelector);
                var activeContainer = document.querySelector(".nul_tabs-container_JS[data-container=" + activeTab + "]");
                if (!!activeContainer) {
                    for (var i = 0; i < accountTabContent.length; i++) {
                        var container = accountTabContent[i];
                        container.classList.add("nul_hidden");
                        activeContainer.classList.remove("nul_hidden");
                    }
                }
            };
            this.triggerSidebarMenu = function(activeTab) {
                var sidebarLinks = document.querySelectorAll(_this_1.navButtonCSSSelector);
                var activeLink = document.querySelector(_this_1.navButtonCSSSelector + "[data-tab=" + activeTab + "]");
                if (!!activeLink) {
                    for (var i = 0; i < sidebarLinks.length; i++) {
                        var sidebarLink = sidebarLinks[i];
                        sidebarLink.classList.remove("nul_active-sidebar-btn");
                        activeLink.classList.add("nul_active-sidebar-btn");
                    }
                }
            };
            this.dashboardViewAllOrders = function() {
                var viewOrdersBtn = document.querySelector(_this_1.dashboardViewAllBtnCSSSelector);
                var dashboardBtn = document.querySelector(_this_1.dashboardSidebarBtnCSSSelector);
                var dashboardContent = document.querySelector(_this_1.dashboardContentCSSSelector);
                var orderBtn = document.querySelector(".nul_orders-sidebar-btn_JS");
                var orderContent = document.querySelector(".nul_account-order-history-wrapper_JS");
                var addressBookContent = document.querySelector(".nul_account-address-book-snippet-wrapper_JS");
                var accountDetailsContent = document.querySelector(".nul_account-details-snippet-wrapper_JS");
                if (!!viewOrdersBtn) {
                    viewOrdersBtn.addEventListener("click", function(e) {
                        e.preventDefault();
                        dashboardContent.classList.add("nul_hidden");
                        orderContent.classList.remove("nul_hidden");
                        addressBookContent.classList.add("nul_hidden");
                        accountDetailsContent.classList.add("nul_hidden");
                        dashboardBtn.classList.remove("nul_active-sidebar-btn");
                        orderBtn.classList.add("nul_active-sidebar-btn");
                    });
                }
            };
            this.copyAffiliateLink = function() {
                var _this = _this_1;
                var affiliateLinkInput = document.querySelector(".nul_affiliate-link-input_JS");
                var copyBtn = document.querySelector(".nul_affiliate-link-copy-btn_JS");
                if (!!copyBtn) {
                    copyBtn.addEventListener("click", function(e) {
                        if (!!affiliateLinkInput) {
                            affiliateLinkInput.select();
                            affiliateLinkInput.setSelectionRange(0, 99999);
                            navigator.clipboard.writeText(affiliateLinkInput.value);
                            _this.notification.init("Copied Replicated Site link to the clipboard!", false);
                        }
                    });
                }
                var copyBtnReplicated = document.querySelector(".nul_replicated-site-link-copy-btn_JS");
                var replicatedInput = document.querySelector(".nul_replicated-site-link_JS");
                if (!!copyBtnReplicated) {
                    copyBtnReplicated.addEventListener("click", function(e) {
                        if (!!replicatedInput) {
                            replicatedInput.select();
                            replicatedInput.setSelectionRange(0, 99999);
                            navigator.clipboard.writeText(replicatedInput.value);
                            _this.notification.init("Copied Replicated Site link to the clipboard!", false);
                        }
                    });
                }
            };
            this.selectAffiliateLabel = function() {
                var affiliateLabel = document.querySelector(".nul_affiliate-link-input_JS");
                var reflink = document.querySelector(".nul_replicated-site-link_JS");
                if (!!affiliateLabel) {
                    affiliateLabel.addEventListener("click", function(e) {
                        affiliateLabel.select();
                        affiliateLabel.setSelectionRange(0, 99999);
                    });
                }
                if (!!reflink) {
                    reflink.addEventListener("click", function(e) {
                        reflink.select();
                        reflink.setSelectionRange(0, 99999);
                    });
                }
            };
            this.subscribeActionsToButtons = function() {
                var _this = _this_1;
                var backofficeBtn = document.querySelector(_this_1.backofficeBtnCSSSelector);
                var autoship = document.querySelector(_this_1.autoshipBtnCSSSelector);
                var loyaltyBtn = document.querySelector(_this_1.loyaltyBtnCSSSelector);
                if (!!backofficeBtn) {
                    var loader_1 = document.createElement("span");
                    loader_1.classList.add("nul_loader-small", "nul_loader-small_JS");
                    backofficeBtn.appendChild(loader_1);
                    backofficeBtn.addEventListener("click", function(e) {
                        if (!backofficeBtn.disabled) {
                            sessionStorage.setItem("btn-bo", "1");
                            _this.autoshipAndbackofficeLink(false, backofficeBtn);
                            backofficeBtn.disabled = true;
                            loader_1.style.display = "inline-block";
                        }
                        clearTimeout(_this.timeoutRef);
                        _this.timeoutRef = setTimeout(function() {
                            var loader = backofficeBtn.querySelector(".nul_loader-small_JS");
                            loader.style.display = "none";
                            backofficeBtn.disabled = false;
                        }, 8e3);
                    });
                }
                if (!!autoship) {
                    var loader_2 = document.createElement("span");
                    loader_2.classList.add("nul_loader-small", "nul_loader-small_JS");
                    autoship.appendChild(loader_2);
                    autoship.addEventListener("click", function(e) {
                        if (!autoship.disabled) {
                            sessionStorage.setItem("btn-a", "1");
                            _this.autoshipAndbackofficeLink(true, autoship);
                            autoship.disabled = true;
                            loader_2.style.display = "inline-block";
                        }
                        clearTimeout(_this.timeoutRef);
                        _this.timeoutRef = setTimeout(function() {
                            var loader = autoship.querySelector(".nul_loader-small_JS");
                            loader.style.display = "none";
                            autoship.disabled = false;
                        }, 8e3);
                    });
                }
                if (!!loyaltyBtn) {
                    var loader_3 = document.createElement("span");
                    loader_3.classList.add("nul_loader-small", "nul_loader-small_JS");
                    loyaltyBtn.appendChild(loader_3);
                    loyaltyBtn.addEventListener("click", function(e) {
                        if (!loyaltyBtn.disabled) {
                            sessionStorage.setItem("btn-a", "1");
                            _this.loyaltyProgramRedirect(loyaltyBtn);
                            loyaltyBtn.disabled = true;
                            loader_3.style.display = "inline-block";
                        }
                        clearTimeout(_this.timeoutRef);
                        _this.timeoutRef = setTimeout(function() {
                            var loader = loyaltyBtn.querySelector(".nul_loader-small_JS");
                            loader.style.display = "none";
                            loyaltyBtn.disabled = false;
                        }, 8e3);
                    });
                }
            };
            this.autoshipAndbackofficeLink = function(autoship, targetButton) {
                var accountPage = document.querySelector(_this_1.accountPageWrapperCSSSelector);
                var customerId = accountPage.getAttribute("data-customer-id").toString();
                var customerTag = accountPage.getAttribute("data-customer-tag");
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["bydesign-sso"],
                    method: "post",
                    contentType: "json",
                    data: {
                        byDesignID: customerId,
                        autoshipRedirect: autoship,
                        customerType: customerTag
                    },
                    callback: function(response) {
                        try {
                            var responseRedirect = JSON.parse(response.response);
                            if (responseRedirect.statusCode === 200) {
                                window.location.href = responseRedirect.data.redirect_to;
                            }
                        } catch (err) {
                            targetButton.disabled = false;
                            console.log("Something went wrong!");
                        }
                    }
                });
            };
            this.loyaltyProgramRedirect = function(targetButton) {
                var accountPage = document.querySelector(_this_1.accountPageWrapperCSSSelector);
                var customerId = accountPage.getAttribute("data-customer-id").toString();
                var customerTag = accountPage.getAttribute("data-customer-tag");
                if (!customerTag.includes("customer")) {
                    return;
                }
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["loyalty-program"],
                    method: "post",
                    contentType: "json",
                    data: {
                        byDesignID: customerId
                    },
                    callback: function(response) {
                        try {
                            var responseRedirect = JSON.parse(response.response);
                            if (responseRedirect.status === 200) {
                                window.location.href = "https://profile.newulife.com/loyalty?customer_guid=" + responseRedirect.data.guid;
                            }
                        } catch (err) {
                            targetButton.disabled = false;
                            console.log("Something went wrong!");
                        }
                    }
                });
            };
            this.hideAddressForms = function() {
                var editAddressesForm = document.querySelectorAll(_this_1.addressFormCSSSelector);
                editAddressesForm.forEach(function(editAddress) {
                    editAddress.classList.add("hide");
                });
            };
            this.triggerAddressMenu = function() {
                var _this = _this_1;
                var addressMenus = document.querySelectorAll(".nul_address-menu-btn_JS");
                addressMenus.forEach(function(menuBtn) {
                    if (!menuBtn.classList.contains("nul_has-event_JS")) {
                        menuBtn.classList.add("nul_has-event_JS");
                        menuBtn.addEventListener("click", function(e) {
                            e.preventDefault();
                            var formId = this.getAttribute("data-form-id");
                            _this.hideAndShowMenu(formId);
                        });
                    }
                });
            };
            this.hideAndShowMenu = function(exceptionFormId) {
                var openMenus = document.querySelectorAll(".nul_address-menu_JS");
                openMenus.forEach(function(menu) {
                    if (menu.getAttribute("data-form-id") != exceptionFormId) {
                        menu.classList.remove("nul_open-menu_JS");
                    } else {
                        if (menu.classList.contains("nul_open-menu_JS")) {
                            menu.classList.remove("nul_open-menu_JS");
                        } else {
                            menu.classList.add("nul_open-menu_JS");
                            _this_1.addBodyClickEvent();
                        }
                    }
                });
            };
            this.addBodyClickEvent = function() {
                var _this = _this_1;
                if (!document.body.classList.contains("nul_has-event_JS")) {
                    document.body.classList.add("nul_has-event_JS");
                    document.body.addEventListener("click", _this.elemEventHandler);
                }
            };
            this.removeBodyEventListener = function(menu) {
                menu.classList.remove("nul_open-menu_JS");
                document.body.classList.remove("nul_has-event_JS");
                document.body.removeEventListener("click", _this_1.elemEventHandler);
            };
            this.elemEventHandler = function(e) {
                e.preventDefault();
                var el = e.target;
                var menu = document.querySelector(".nul_address-menu_JS.nul_open-menu_JS");
                if (!!menu) {
                    if (!_this_1.generalMethods.getClosestByClass(e.target, "nul_address-menu-btn_JS")) {
                        _this_1.removeBodyEventListener(menu);
                    }
                    if (el.classList.contains("nul_address-edit-toggle_JS")) {
                        _this_1.editAddress(el);
                    }
                    if (el.classList.contains("nul_address-delete")) {
                        _this_1.deleteAddressInfo(el);
                    }
                }
            };
            this.closeForm = function() {
                var _this = _this_1;
                var closeFormBtns = document.querySelectorAll(".nul_close-form_JS");
                closeFormBtns.forEach(function(el) {
                    if (!el.classList.contains("nul_has-event_JS")) {
                        el.classList.add("nul_has-event_JS");
                        el.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this.hideAddressForms();
                        });
                    }
                });
            };
            this.openAddAddressForm = function() {
                var _this = _this_1;
                document.querySelectorAll(".nul_address-new-toggle_JS").forEach(function(el) {
                    if (!el.classList.contains("nul_has-event_JS")) {
                        el.classList.add("nul_has-event_JS");
                        el.addEventListener("click", function() {
                            _this.hideAddressForms();
                            _this.showAddAddressForm();
                        });
                    }
                });
            };
            this.showAddAddressForm = function() {
                var newAddressForm = document.querySelector(".nul_new-address-form_JS");
                if (!!newAddressForm) {
                    newAddressForm.classList.remove("hide");
                    _this_1.liveTrimValue(newAddressForm);
                }
            };
            this.deleteAddressInfo = function(triggerBtn) {
                var formId = triggerBtn.getAttribute("data-form-id");
                var confirmMessage = triggerBtn.getAttribute("data-confirm-message");
                if (confirm(confirmMessage || "Are you sure you wish to delete this address?")) {
                    _this_1.deleteReguest(formId);
                }
            };
            this.deleteReguest = function(formId) {
                var _this = _this_1;
                _this.ajax.send({
                    endpoint: window.location.protocol + "//" + window.location.hostname + _this.endpoint["account-addresses"] + "/" + formId,
                    method: "POST",
                    contentType: "form",
                    data: {
                        _method: "delete"
                    },
                    callback: function(res, req) {
                        window.location.reload();
                    }
                });
            };
            this.addAddress = function() {
                var _this = _this_1;
                var formElements = document.querySelectorAll(".nul_add-address-btn_JS");
                var _loop_1 = function(i) {
                    var formElement = formElements[i];
                    if (!!formElement) {
                        if (!formElement.classList.contains("nul_has-event_JS")) {
                            formElement.classList.add("nul_has-event_JS");
                            formElement.addEventListener("submit", function(e) {
                                e.preventDefault();
                                _this.submitAddAddress(formElement);
                            });
                        }
                    }
                };
                for (var i = 0; i < formElements.length; i++) {
                    _loop_1(i);
                }
            };
            this.submitAddAddress = function(formElement) {
                var _this = _this_1;
                var formData = _this.form.collectFormData(formElement);
                var requestData = formData;
                _this.ajax.send({
                    endpoint: window.location.protocol + "//" + window.location.hostname + _this.endpoint["account-addresses"],
                    method: "POST",
                    contentType: "form",
                    data: requestData,
                    callback: function(res, req) {
                        window.location.reload();
                    }
                });
            };
            this.disableBtnsAutoshipAndBackoffice = function() {
                var accountSidebar = document.querySelector(_this_1.accountSidebarCSSSelector);
                if (!!accountSidebar) {
                    var accountPage = document.querySelector(_this_1.accountPageWrapperCSSSelector);
                    var btnMessage = document.querySelector(".nul_button-message_JS");
                    var customerId = accountPage.getAttribute("data-customer-id").toString();
                    var customerTag = accountPage.getAttribute("data-customer-tag");
                    var backoffice = accountSidebar.querySelector(_this_1.backofficeBtnCSSSelector);
                    var autoship = accountSidebar.querySelector(_this_1.autoshipBtnCSSSelector);
                    if (customerId === "" && customerTag === "") {
                        backoffice.disabled = true;
                        backoffice.style.opacity = "0.5";
                        autoship.disabled = true;
                        autoship.style.opacity = "0.5";
                        if (!!btnMessage) {
                            btnMessage.classList.remove("nul_hidden");
                        }
                    } else {
                        backoffice.disabled = false;
                        backoffice.style.opacity = "1";
                        autoship.disabled = false;
                        autoship.style.opacity = "1";
                        if (!!btnMessage) {
                            btnMessage.classList.add("nul_hidden");
                        }
                    }
                }
            };
            this.generalMethods = general_methods_5.StGeneralMethods.Instance;
            this.objectFormatting = object_formatting_5.StObjectFormatting.Instance;
            this.static = static_10.StStatic.Instance;
            this.form = form_1.StForm.Instance;
            this.endpoint = this.static.obtainStaticEndpoints();
            this.ajax = ajax_8.StAjax.Instance;
            this.url = url_3.StUrl.Instance;
            this.notification = notification_2.STNotification.Instance;
            this.init();
        }
        Object.defineProperty(StAccount, "Instance", {
            get: function() {
                return this._instance || (this._instance = new this());
            },
            enumerable: false,
            configurable: true
        });
        StAccount.prototype.editAddress = function(el) {
            var addressWrapper = document.querySelectorAll(".nul_add-or-edit-address-content_JS");
            for (var i = 0; i < addressWrapper.length; i++) {
                addressWrapper[i].classList.add("hide");
            }
            var formId = el.getAttribute("data-form-id");
            if (!!formId) {
                var editAdrressForm = document.getElementById("EditAddress_" + formId);
                editAdrressForm.classList.toggle("hide");
                this.liveTrimValue(editAdrressForm);
            }
        };
        return StAccount;
    }();
    exports.StAccount = StAccount;
});

define("users/cart", [ "require", "exports", "general-methods/general-methods", "general-methods/object-formatting", "general-methods/url", "general-methods/ajax", "static/static", "general-methods/notification" ], function(require, exports, general_methods_6, object_formatting_6, url_4, ajax_9, static_11, notification_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCart = void 0;
    var variantType;
    (function(variantType) {
        variantType[variantType["subOrMonthly"] = 0] = "subOrMonthly";
        variantType[variantType["oneTime"] = 1] = "oneTime";
    })(variantType || (variantType = {}));
    var StCart = function() {
        function StCart() {
            var _this_1 = this;
            this.className = "Account";
            this.sessionAlias = {
                getAlias: function() {
                    return !!window.sessionStorage.getItem("als") ? window.sessionStorage.getItem("als") : _this_1.static.defaultAlias;
                }
            };
            this.init = function() {
                var _this = _this_1;
                _this_1.generalMethods.subscribeDOMLoaded(function() {
                    _this.fetchInterceptorInit();
                    _this.initCloseCartBtn();
                    _this.checkoutFlow();
                    _this.initTermsModal();
                    _this.getCart(_this.manageCartFetchContent);
                    _this.dispatchCartOpen();
                    _this.clearCartOnItemUserMismatch();
                });
            };
            this.initCloseCartBtn = function() {
                var closeCartBtn = document.querySelector(".st_close-cart_JS");
                closeCartBtn === null || closeCartBtn === void 0 ? void 0 : closeCartBtn.addEventListener("click", function(e) {
                    _this_1.dispatchCartClose();
                });
            };
            this.dispatchCartClose = function() {
                document.documentElement.dispatchEvent(new CustomEvent("cart:close", {
                    bubbles: true
                }));
            };
            this.clearCartOnItemUserMismatch = function() {
                var itemKeyParagraph = document.querySelector(".st_cart-clear_JS");
                var reqObj = {};
                if (!!itemKeyParagraph) {
                    var itemsToRemove = itemKeyParagraph.innerText.replace(/(\r\n|\n|\r)/gm, "").split(",");
                    if (itemsToRemove.length > 0) {
                        itemsToRemove.forEach(function(item) {
                            var _a;
                            var trimmedValue = item.trim();
                            if (trimmedValue.length > 0) {
                                reqObj = __assign(__assign({}, reqObj), (_a = {}, 
                                _a[trimmedValue] = 0, _a));
                            }
                        });
                        _this_1.updateCart(reqObj, _this_1.dispatchCartBuild);
                    }
                }
            };
            this.dispatchCartOpen = function() {
                var redirect = sessionStorage.getItem("redirect");
                if (document.referrer.endsWith("/cart") && !!redirect) {
                    sessionStorage.removeItem("redirect");
                    setTimeout(function() {
                        document.documentElement.dispatchEvent(new CustomEvent("cart:open", {
                            bubbles: true
                        }));
                    }, 500);
                }
            };
            this.initTermsModal = function() {
                var _this = _this_1;
                var termsDescAnchor = document.querySelector(".st_cart-terms-anchor_JS");
                var termsModal = document.querySelector(".st_terms--modal_JS");
                if (!!termsDescAnchor) {
                    termsDescAnchor.onclick = function() {
                        _this.ajax.send({
                            endpoint: _this.endpoint["get-terms"],
                            method: "POST",
                            contentType: "json",
                            data: {
                                termsID: _this.termsID,
                                subTermsID: _this.hasSub ? _this.subTermsID : undefined
                            },
                            callback: function(res) {
                                var termsInfo = JSON.parse(res.response);
                                if (termsInfo.status === 200) {
                                    _this.renderTerms(termsInfo.data);
                                    _this.hideTermsModalLoader();
                                    _this.showTermsModalContent();
                                    _this.scrollTermsContentTop();
                                }
                            }
                        });
                        termsModal.classList.remove("st_modal-close");
                        termsModal.classList.add("st_modal-open");
                        termsModal.classList.add("st_prevent-drawer-close");
                    };
                }
            };
            this.renderTerms = function(terms) {
                var termsContentWrapper = document.querySelector(".st_terms--modal-content_JS");
                var termsContent = document.querySelector(".st_terms--modal--terms-content_JS");
                var closeBtn = _this_1.createTermsCloseBtn();
                if (terms.length === 1 || terms.length === 0) {
                    termsContentWrapper.style.height = "200px";
                    termsContent.style.overflowY = "auto";
                }
                if (terms.length > 1) {
                    termsContentWrapper.style.height = "400px";
                    termsContent.style.overflowY = "scroll";
                }
                termsContent.innerHTML = "";
                if (!!termsContent) {
                    terms.forEach(function(term) {
                        var containerDiv = document.createElement("div");
                        var termHeading = document.createElement("h4");
                        termHeading.innerHTML = term.Description;
                        containerDiv.appendChild(termHeading);
                        if (!!term.DocumentURL) {
                            containerDiv.innerHTML += '<p><a class="st_terms--modal--anchor" href="'.concat(term.DocumentURL, '" target="_blank">View terms and condition.</a></p>');
                        }
                        if (!!term.DocumentText) {
                            containerDiv.innerHTML += term.DocumentText;
                        }
                        termsContent.appendChild(containerDiv);
                    });
                    termsContent.appendChild(closeBtn);
                }
            };
            this.scrollTermsContentTop = function() {
                var termsContent = document.querySelector(".st_terms--modal--terms-content_JS");
                termsContent.scrollTop = 0;
            };
            this.createTermsCloseBtn = function() {
                var _this = _this_1;
                var btnContainer = document.createElement("div");
                var btn = document.createElement("button");
                btnContainer.className = "st_terms--modal--btn-container";
                btn.className = "btn st_terms--modal--close-button button st_terms--modal--close-button_JS";
                btn.innerHTML = "Close";
                btn.onclick = function() {
                    var termsModal = document.querySelector(".st_terms--modal_JS");
                    termsModal.classList.remove("st_modal-open");
                    termsModal.classList.add("st_modal-close");
                    _this.hideTermsModalContent();
                    _this.showTermsModalLoader();
                };
                btnContainer.appendChild(btn);
                return btnContainer;
            };
            this.showTermsModalContent = function() {
                var termsContentInnerWrapper = document.querySelector(".st_terms--modal--terms-content_JS");
                if (!!termsContentInnerWrapper) {
                    termsContentInnerWrapper.style.display = "flex";
                }
            };
            this.hideTermsModalContent = function() {
                var termsContentInnerWrapper = document.querySelector(".st_terms--modal--terms-content_JS");
                if (!!termsContentInnerWrapper) {
                    termsContentInnerWrapper.style.display = "none";
                }
            };
            this.showTermsModalLoader = function() {
                var termsLoader = document.querySelector(".st_loader-container_JS");
                if (!!termsLoader) {
                    termsLoader.style.display = "flex";
                }
            };
            this.hideTermsModalLoader = function() {
                var termsLoader = document.querySelector(".st_loader-container_JS");
                if (!!termsLoader) {
                    termsLoader.style.display = "none";
                }
            };
            this.windowTermsModalClose = function(event) {
                var termsModal = document.querySelector(".st_terms--modal_JS");
                if (event.target == termsModal) {
                    termsModal.classList.remove("st_modal-open");
                    termsModal.classList.add("st_modal-close");
                    _this_1.hideTermsModalContent();
                    _this_1.showTermsModalLoader();
                }
            };
            this.checkoutFlow = function() {
                var _this = _this_1;
                var isLoggedIn = !!window.customerInfo;
                _this_1.attributesAdded = false;
                var checkoutButton = document.querySelector(".st_checkout-btn_JS");
                if (!!checkoutButton) {
                    checkoutButton.addEventListener("click", function(e) {
                        if (_this_1.attributesAdded) {
                            _this_1.attributesAdded = !_this_1.attributesAdded;
                            var hasSHOBtag = !!window.customerTags && window.customerTags.filter(function(tag) {
                                return tag.includes("shopping_on_behalf");
                            }).length >= 1;
                            if (hasSHOBtag) {
                                _this.getCart(_this.generateCustomCheckout);
                            } else {
                                window.location.href = "/checkout";
                            }
                        } else {
                            e.preventDefault();
                            if (isLoggedIn) {
                                _this_1.checkoutAgreeToTerms(e, checkoutButton);
                            } else {
                                _this_1.cartUpdateOnCheckout(e, checkoutButton);
                            }
                        }
                    });
                }
            };
            this.checkoutAgreeToTerms = function(e, checkoutButton) {
                var _this = _this_1;
                var requestData = _this.createAgreeToTermsRequestData();
                console.log(requestData);
                _this_1.ajax.send({
                    endpoint: _this.endpoint["agree-to-terms"],
                    method: "POST",
                    contentType: "json",
                    data: requestData,
                    callback: function(res) {
                        try {
                            res = JSON.parse(res.response);
                        } catch (e) {
                            _this.notification.init("Server error, try again!", true);
                        }
                        if (res.message === "Success") {
                            console.log("Agree to terms passed!");
                            _this.cartUpdateOnCheckout(e, checkoutButton);
                        } else {
                            _this.notification.init("Something went wrong, try again!", true);
                        }
                    }
                });
            };
            this.cartUpdateOnCheckout = function(e, checkoutButton) {
                _this_1.getCart(function(res) {
                    try {
                        var cartObj = JSON.parse(res.response);
                        var items = cartObj.items;
                        var noteInput = document.querySelector(".st_hidden-cart-notes-input_JS");
                        var cartAttr = _this_1.generateCartAttributes(items);
                        console.log(cartAttr);
                        var _this_4 = _this_1;
                        _this_1.updateCartNoteOrAttributes({
                            note: noteInput.value,
                            attributes: cartAttr
                        }, function(updateRes) {
                            if (res.status === 200) {
                                _this_4.attributesAdded = !_this_4.attributesAdded;
                                console.log("Cart update passed!");
                                checkoutButton.dispatchEvent(e);
                            } else {
                                _this_4.notification.init("Server error, try again!", true);
                            }
                        });
                    } catch (err) {
                        console.log("Error while parsing cart data --\x3e", err);
                    }
                });
            };
            this.hasSubscriptionItem = function(items) {
                var _a;
                var hasItem = false;
                for (var i = 0; i < items.length; i++) {
                    if (hasItem) break;
                    if ((_a = items[i]) === null || _a === void 0 ? void 0 : _a.variant_options.includes("Subscription")) hasItem = true;
                }
                return hasItem;
            };
            this.generateCartAttributes = function(cartItems) {
                var cartAttr = {};
                var isLoggedIn = !!window.customerInfo;
                var tagName = "shopifyUUID";
                var tags = window.customerTags;
                var uuid = !!tags ? tags.filter(function(tag) {
                    return tag.includes(tagName);
                })[0] : false;
                var hasSubscriptionItem = _this_1.hasSubscriptionItem(cartItems);
                if (!!uuid && isLoggedIn) {
                    uuid = uuid.slice(tagName.length + 1);
                    cartAttr = {
                        UUID: uuid
                    };
                }
                if (!isLoggedIn) {
                    cartAttr = {
                        termsID: _this_1.termsID
                    };
                }
                cartAttr = __assign(__assign({}, cartAttr), {
                    subscription: hasSubscriptionItem
                });
                return cartAttr;
            };
            this.createAgreeToTermsRequestData = function() {
                var repID = window.repID;
                var customerID = window.customerID;
                var requestData;
                if (repID.length > 0) {
                    requestData = {
                        repDID: repID,
                        termIDs: _this_1.hasSub ? [ _this_1.termsID, _this_1.subTermsID ] : [ _this_1.termsID ]
                    };
                }
                if (customerID.length > 0) {
                    requestData = {
                        customerDID: customerID,
                        termIDs: _this_1.hasSub ? [ _this_1.termsID, _this_1.subTermsID ] : [ _this_1.termsID ]
                    };
                }
                return requestData;
            };
            this.fetchInterceptorInit = function() {
                var _this = _this_1;
                var originalFetch = window.fetch;
                window.fetch = function() {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    return __awaiter(_this_1, void 0, void 0, function() {
                        var resource, config, cartEndpoints, response;
                        return __generator(this, function(_a) {
                            switch (_a.label) {
                              case 0:
                                resource = args[0], config = args[1];
                                cartEndpoints = [ "/cart/add.js", "/cart/update.js", "/cart/change.js", "/cart/clear.js", "/wallets/checkouts/" ];
                                return [ 4, originalFetch(resource, config) ];

                              case 1:
                                response = _a.sent();
                                if (response.url.endsWith("/cart.json") || _this.matchUrlSnippet(response.url, cartEndpoints)) {
                                    _this.getCart(_this.manageCartFetchContent);
                                }
                                return [ 2, response ];
                            }
                        });
                    });
                };
            };
            this.generateCustomCheckout = function(res) {
                var cartObj = JSON.parse(res.response);
                var items = cartObj.items;
                if (items.length > 0) {
                    var customCheckoutArgs_1 = {};
                    var sobInfo = window.sobInfo;
                    if (!!sobInfo) {
                        var address1 = sobInfo.address1, address2 = sobInfo.address2, city = sobInfo.city, country = sobInfo.country, firstName = sobInfo.firstName, lastName = sobInfo.lastName, province = sobInfo.province, zip = sobInfo.zip, phone = sobInfo.phone, company = sobInfo.company, email = sobInfo.email;
                        customCheckoutArgs_1["email"] = email;
                        customCheckoutArgs_1["shippingAddress"] = {
                            address1: !!address1 ? address1 : "",
                            address2: !!address2 ? address2 : "",
                            city: !!city ? city : "",
                            country: !!country ? country : "",
                            firstName: !!firstName ? firstName : "",
                            lastName: !!lastName ? lastName : "",
                            province: !!province ? province : "",
                            zip: !!zip ? zip : "",
                            phone: !!phone ? phone : "",
                            company: !!company ? company : ""
                        };
                        console.log(cartObj);
                        customCheckoutArgs_1["lineItems"] = [];
                        items.forEach(function(item) {
                            customCheckoutArgs_1["lineItems"].push({
                                variantId: "gid://shopify/ProductVariant/".concat(item.variant_id),
                                quantity: item.quantity
                            });
                        });
                        customCheckoutArgs_1["note"] = cartObj.note;
                        customCheckoutArgs_1["customAttributes"] = [];
                        Object.keys(cartObj.attributes).forEach(function(attrKey) {
                            customCheckoutArgs_1["customAttributes"].push({
                                key: attrKey,
                                value: cartObj.attributes[attrKey]
                            });
                        });
                        console.log(customCheckoutArgs_1);
                        _this_1.getCustomCheckout(_this_1.manageCustomCheckoutRes, customCheckoutArgs_1);
                    }
                }
            };
            this.getCustomCheckout = function(responseHandle, requestData) {
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["sob-checkout"],
                    method: "POST",
                    contentType: "json",
                    data: requestData,
                    callback: responseHandle
                });
            };
            this.getCart = function(responseHandle) {
                _this_1.ajax.send({
                    endpoint: "/cart.js",
                    method: "GET",
                    contentType: "json",
                    callback: responseHandle
                });
            };
            this.updateCart = function(updateDataObj, responseHandle) {
                _this_1.ajax.send({
                    endpoint: "/cart/update.js",
                    method: "POST",
                    contentType: "json",
                    data: {
                        updates: updateDataObj
                    },
                    callback: responseHandle
                });
            };
            this.updateCartNoteOrAttributes = function(updateDataObj, responseHandle) {
                _this_1.ajax.send({
                    endpoint: "/cart/update.js",
                    method: "POST",
                    contentType: "json",
                    data: updateDataObj,
                    callback: responseHandle
                });
            };
            this.clearCart = function(responseHandle) {
                _this_1.ajax.send({
                    endpoint: "/cart/clear.js",
                    method: "POST",
                    contentType: "json",
                    data: {},
                    callback: responseHandle
                });
            };
            this.manageCustomCheckoutRes = function(res) {
                var response = JSON.parse(res.response);
                var webUrl = response.data.webUrl;
                if (!!webUrl) {
                    window.location.href = webUrl;
                }
            };
            this.manageCartFetchContent = function(res) {
                var isLoggedIn = !!window.customerInfo;
                var checkbox = document.querySelector(".st_cart-terms-wrapper_JS").querySelector("input");
                if (!!checkbox) {
                    _this_1.isAgreeChecked = checkbox.checked;
                }
                var cartObj = JSON.parse(res.response);
                var items = cartObj.items;
                if (items.length > 0) {
                    _this_1.showTerms();
                    var hasSub = items.find(function(item) {
                        return _this_1.includesVariant(variantType.subOrMonthly, item);
                    }) !== undefined;
                    var hasOneTime = items.find(function(item) {
                        return _this_1.includesVariant(variantType.oneTime, item);
                    }) !== undefined;
                    if (isLoggedIn) {
                        if (_this_1.isAgreeChecked) {
                            if (_this_1.hasSub === hasSub && _this_1.hasOneTime === hasOneTime) {
                                _this_1.toggleCheckboxChange(true);
                            } else {
                                _this_1.toggleCheckboxChange(false);
                            }
                        }
                        _this_1.hasSub = hasSub;
                        _this_1.hasOneTime = hasOneTime;
                    } else {
                        _this_1.hasSub = false;
                    }
                }
            };
            this.showTerms = function() {
                var termsWrapper = document.querySelector(".st_cart-terms-wrapper_JS");
                var checkoutButton = document.querySelector(".st_checkout-btn_JS");
                if (!!termsWrapper) {
                    var checkbox = termsWrapper.querySelector("input");
                    checkbox.checked = _this_1.isAgreeChecked;
                    checkoutButton.disabled = !_this_1.isAgreeChecked;
                    checkbox.removeEventListener("change", function() {
                        return _this_1.toggleCheckboxChange();
                    });
                    checkbox.addEventListener("change", function() {
                        return _this_1.toggleCheckboxChange();
                    });
                    termsWrapper.style.display = "flex";
                }
            };
            this.toggleCheckboxChange = function(checked) {
                var checkoutButton = document.querySelector(".st_checkout-btn_JS");
                var checkbox = document.querySelector(".st_cart-terms-wrapper_JS").querySelector("input");
                if (!(!!checkoutButton && !!checkbox)) {
                    return;
                }
                var webAlias = _this_1.sessionAlias.getAlias();

                if (checked === undefined) {
                    _this_1.isAgreeChecked = checkbox.checked;
                    // if (!webAlias || webAlias === "1") {
                    //     checkoutButton.disabled = true;
                    // } else {
                        checkoutButton.disabled = !checkbox.checked;
                    // }
                } else {
                    _this_1.isAgreeChecked = checked;
                    checkbox.checked = checked;
                    // if (!webAlias || webAlias === "1") {
                    //     checkoutButton.disabled = true;
                    // } else {
                        checkoutButton.disabled = !checked;
                    // }
                }
            };
            this.hideTerms = function() {
                var termsWrapper = document.querySelector(".st_cart-terms-wrapper_JS");
                var checkoutButton = document.querySelector(".st_checkout-btn_JS");
                var checkbox = termsWrapper.querySelector("input");
                checkbox.checked = false;
                termsWrapper.style.display = "none";
                checkoutButton.disabled = false;
            };
            this.removeSubItemsFromCart = function(items) {
                var _this = _this_1;
                var updateObj = {};
                items.forEach(function(item) {
                    var _a;
                    var hasSub = _this.includesVariant(variantType.subOrMonthly, item);
                    if (hasSub) {
                        updateObj = __assign(__assign({}, updateObj), (_a = {}, 
                        _a[item.id] = 0, _a));
                    }
                });
                _this_1.updateCart(updateObj, _this_1.dispatchCartBuild);
            };
            this.includesVariant = function(variant, item) {
                if (variant === variantType.subOrMonthly) {
                    return item.options_with_values.findIndex(function(option) {
                        return option.value === "Subscription" || option.value === "Monthly";
                    }) !== -1;
                }
                if (variant === variantType.oneTime) {
                    return item.options_with_values.findIndex(function(option) {
                        return option.value === "One Time";
                    }) !== -1;
                }
            };
            this.dispatchCartBuild = function() {
                document.documentElement.dispatchEvent(new CustomEvent("cart:build", {
                    bubbles: true
                }));
            };
            this.matchUrlSnippet = function(url, urlSnippetArr) {
                for (var snippet in urlSnippetArr) {
                    if (url.includes(snippet)) {
                        return true;
                    }
                }
                return false;
            };
            this.isJsonString = function(str) {
                try {
                    JSON.parse(str);
                } catch (e) {
                    return false;
                }
                return true;
            };
            this.generalMethods = general_methods_6.StGeneralMethods.Instance;
            this.objectFormatting = object_formatting_6.StObjectFormatting.Instance;
            this.static = static_11.StStatic.Instance;
            this.endpoint = this.static.obtainStaticEndpoints();
            this.ajax = ajax_9.StAjax.Instance;
            this.url = url_4.StUrl.Instance;
            this.notification = notification_3.STNotification.Instance;
            this.subTermsID = window.stAppConfig.subTermsID;
            this.termsID = window.stAppConfig.termsID;
            this.hasSub = false;
            this.hasOneTime = false;
            this.isAgreeChecked = false;
            this.init();
        }
        Object.defineProperty(StCart, "Instance", {
            get: function() {
                return this._instance || (this._instance = new this());
            },
            enumerable: false,
            configurable: true
        });
        return StCart;
    }();
    exports.StCart = StCart;
});

define("users/shop-guard", [ "require", "exports", "general-methods/general-methods", "general-methods/ajax", "static/static" ], function(require, exports, general_methods_7, ajax_10, static_12) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StShopGuard = void 0;
    var StShopGuard = function() {
        function StShopGuard() {
            var _this_1 = this;
            this.className = "ShopGuard";
            this.init = function() {
                var _this = _this_1;
                _this_1.generalMethods.subscribeDOMLoaded(function() {
                    _this.changeMarket();
                    _this.koreaRedirect();
                    _this.defaultMarket();
                });
            };
            this.defaultMarket = function() {
                var selectCountry = document.querySelector(".nul_select-country_JS");
                if (!!selectCountry) {
                    var selectedOption = void 0;
                    var country = window.stAppConfig.country;
                    selectedOption = selectCountry.namedItem(country);
                    if (!!selectedOption) {
                        selectCountry.value = selectedOption.value;
                    } else {
                        _this_1.redirectToShop(selectCountry);
                    }
                }
            };
            this.changeMarket = function() {
                var _this = _this_1;
                var selectCountry = document.querySelector(".nul_select-country_JS");
                if (!!selectCountry) {
                    selectCountry.addEventListener("change", function(e) {
                        e.preventDefault();
                        var marketName = selectCountry.options[selectCountry.selectedIndex].getAttribute("name");
                        var marketUrl = selectCountry.options[selectCountry.selectedIndex].value;
                        var customerTags = window.customerTags;
                        if (!marketUrl.includes("korea") || marketUrl.includes("korea") && (customerTags === null || customerTags === void 0 ? void 0 : customerTags.includes("korea"))) {
                            _this_1.shopChange(marketName, marketUrl);
                        } else {
                            _this.defaultMarket();
                        }
                    });
                }
            };
            this.shopChange = function(marketName, marketUrl) {
                var isCustomerLoggedIn = !!window.customerInfo;
                if (isCustomerLoggedIn) {
                    _this_1.marketChangeForCustomer(marketName);
                } else {
                    _this_1.marketChangeForGuest(marketUrl);
                }
            };
            this.marketChangeForGuest = function(selectedMarketUrl) {
                var currentUrl = window.location.origin;
                var currentPathName = window.location.pathname;
                if (currentUrl !== selectedMarketUrl) {
                    var selectedMarket = selectedMarketUrl + currentPathName;
                    window.location.assign(selectedMarket);
                }
            };
            this.marketChangeForCustomer = function(marketName) {
                var customerEmail = window.customerEmail;
                if (!!customerEmail) {
                    var customerRoute = window.location.pathname;
                    var dataMarket = {
                        email: customerEmail,
                        market: marketName,
                        redirect_url: customerRoute
                    };
                    _this_1.ajax.send({
                        endpoint: _this_1.endpoint["multipass-link"],
                        method: "POST",
                        contentType: "json",
                        data: dataMarket,
                        callback: function(res, req) {
                            res = JSON.parse(res.response);
                            var respURL = res.data.url.toString();
                            if (res.statusCode === 200) {
                                window.location.assign(respURL);
                            } else {}
                        }
                    });
                }
            };
            this.koreaRedirect = function() {
                var tags = window.customerTags;
                var url = window.location.href;
                if (!(tags === null || tags === void 0 ? void 0 : tags.includes("korea")) && url.includes("korea")) {
                    _this_1.defaultMarket();
                }
            };
            this.redirectToShop = function(selectCountry) {
                var _a;
                var redirectCountry = "United States";
                var redirectURL = (_a = selectCountry.namedItem(redirectCountry)) === null || _a === void 0 ? void 0 : _a.value;
                _this_1.shopChange(redirectCountry, redirectURL);
            };
            this.generalMethods = general_methods_7.StGeneralMethods.Instance;
            this.static = static_12.StStatic.Instance;
            this.endpoint = this.static.obtainStaticEndpoints();
            this.ajax = ajax_10.StAjax.Instance;
            this.init();
        }
        Object.defineProperty(StShopGuard, "Instance", {
            get: function() {
                return this._instance || (this._instance = new this());
            },
            enumerable: false,
            configurable: true
        });
        return StShopGuard;
    }();
    exports.StShopGuard = StShopGuard;
});

define("users/account.orders.payment.status", [ "require", "exports", "general-methods/general-methods", "general-methods/object-formatting", "general-methods/form", "general-methods/ajax", "static/static", "general-methods/url", "general-methods/notification" ], function(require, exports, general_methods_8, object_formatting_7, form_2, ajax_11, static_13, url_5, notification_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountOrdersPayment = void 0;
    var StAccountOrdersPayment = function() {
        function StAccountOrdersPayment() {
            var _this_1 = this;
            this.className = "Account";
            this.init = function() {
                var _this = _this_1;
                _this_1.generalMethods.subscribeDOMLoaded(function() {});
            };
            this.generalMethods = general_methods_8.StGeneralMethods.Instance;
            this.objectFormatting = object_formatting_7.StObjectFormatting.Instance;
            this.static = static_13.StStatic.Instance;
            this.form = form_2.StForm.Instance;
            this.endpoint = this.static.obtainStaticEndpoints();
            this.ajax = ajax_11.StAjax.Instance;
            this.url = url_5.StUrl.Instance;
            this.notification = notification_4.STNotification.Instance;
            this.init();
        }
        Object.defineProperty(StAccountOrdersPayment, "Instance", {
            get: function() {
                return this._instance || (this._instance = new this());
            },
            enumerable: false,
            configurable: true
        });
        return StAccountOrdersPayment;
    }();
    exports.StAccountOrdersPayment = StAccountOrdersPayment;
});

define("users/share-widget", [ "require", "exports", "general-methods/general-methods", "general-methods/ajax", "general-methods/object-formatting", "static/static", "general-methods/url", "general-methods/notification" ], function(require, exports, general_methods_9, ajax_12, object_formatting_8, static_14, url_6, notification_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StShareWidget = void 0;
    var StShareWidget = function() {
        function StShareWidget() {
            var _this_1 = this;
            this.className = "ShareWidget";
            this.sessionAlias = {
                getAlias: function() {
                    return !!window.sessionStorage.getItem("als") ? window.sessionStorage.getItem("als") : _this_1.static.defaultAlias;
                },
                setAlias: function(alias) {
                    window.sessionStorage.setItem("als", alias);
                }
            };
            this.init = function() {
                var _this = _this_1;
                _this_1.generalMethods.subscribeDOMLoaded(function() {
                    _this.copyAffiliateLink();
                    var button = document.querySelector(".share-widget-button");
                    button.addEventListener("click", function(event) {
                        _this.toggleModal(event);
                    });
                    var closePanel = document.querySelector(".share-widget-close-plane");
                    closePanel.addEventListener("click", function(event) {
                        event.stopPropagation();
                        console.log("closePanel", closePanel);
                        _this.closeModal(event);
                    });
                });
            };
            this.copyAffiliateLink = function() {
                var _this = _this_1;
                var promotionNotificationText = "Copied Promotion Site link to the clipboard!";
                var promotionMaterial = "New U Life";
                var shareWidgetText = "Spread the word about ".concat(promotionMaterial, " for Better Health");
                var shareWidgetTextDiv = document.querySelector(".share-widget-text3");
                shareWidgetTextDiv.innerText = shareWidgetText;
                var shareWidgetLinkInput = document.querySelector(".share-widget-link-input_JS");
                setTimeout(function() {
                    var alias = _this_1.sessionAlias.getAlias();
                    shareWidgetLinkInput.value = "https://".concat(alias, ".newulife.com/");
                }, 1e3);
                var copyBtn = document.querySelector(".share-widget-link-copy-btn_JS");
                if (!!copyBtn) {
                    copyBtn.addEventListener("click", function(e) {
                        if (!!shareWidgetLinkInput) {
                            shareWidgetLinkInput.select();
                            shareWidgetLinkInput.setSelectionRange(0, 99999);
                            navigator.clipboard.writeText(shareWidgetLinkInput.value);
                            this.notification.init(promotionNotificationText, false);
                        }
                    });
                }
            };
            this.generalMethods = general_methods_9.StGeneralMethods.Instance;
            this.objectFormatting = object_formatting_8.StObjectFormatting.Instance;
            this.static = static_14.StStatic.Instance;
            this.endpoint = this.static.obtainStaticEndpoints();
            this.ajax = ajax_12.StAjax.Instance;
            this.url = url_6.StUrl.Instance;
            this.notification = notification_5.STNotification.Instance;
            this.init();
        }
        Object.defineProperty(StShareWidget, "Instance", {
            get: function() {
                return this._instance || (this._instance = new this());
            },
            enumerable: false,
            configurable: true
        });
        StShareWidget.prototype.toggleModal = function(event) {
            var parentDisplay = document.querySelector(".parent-display");
            parentDisplay.querySelector(".share-widget-modal").classList.toggle("share_widget_hidden");
            document.querySelector(".share-widget-close-plane").classList.toggle("nul_hidden");
        };
        StShareWidget.prototype.closeModal = function(event) {
            var parentDisplay = document.querySelector(".parent-display");
            parentDisplay.querySelector(".share-widget-modal").classList.add("share_widget_hidden");
            document.querySelector(".share-widget-close-plane").classList.add("nul_hidden");
        };
        return StShareWidget;
    }();
    exports.StShareWidget = StShareWidget;
});

define("static/app-di-config", [ "require", "exports", "static/static", "users/find-rep", "users/shopping-on-behalf", "users/account", "webalias/webalias", "users/cart", "users/shop-guard", "checkout/checkout", "users/rep-info", "users/account.orders.payment.status", "users/share-widget" ], function(require, exports, static_15, find_rep_1, shopping_on_behalf_1, account_1, webalias_2, cart_1, shop_guard_1, checkout_1, rep_info_2, account_orders_payment_status_1, share_widget_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAppDIConfig = void 0;
    var StAppDIConfig = function() {
        function StAppDIConfig() {
            this.className = "stAppDIConfig";
            this.getServices = function(appName) {
                console.log(appName);
                var services = [ static_15.StStatic.Instance ];
                switch (appName) {
                  case "main":
                    services = services.concat([ find_rep_1.StFindRep.Instance, webalias_2.StWebAlias.Instance, shopping_on_behalf_1.StShoppingOnBehalf.Instance, account_1.StAccount.Instance, account_orders_payment_status_1.StAccountOrdersPayment.Instance, shop_guard_1.StShopGuard.Instance, cart_1.StCart.Instance, rep_info_2.StRepInfo.Instance, share_widget_1.StShareWidget.Instance ]);
                    break;

                  case "checkout":
                    services = services.concat([ checkout_1.StCheckout.Instance ]);
                    break;
                }
                console.log(services);
                return services;
            };
        }
        Object.defineProperty(StAppDIConfig, "Instance", {
            get: function() {
                return this._instance || (this._instance = new this());
            },
            enumerable: false,
            configurable: true
        });
        return StAppDIConfig;
    }();
    exports.StAppDIConfig = StAppDIConfig;
});

define("di-container/di-container", [ "require", "exports", "general-methods/general-methods", "static/static", "static/app-di-config", "users/find-rep", "users/cart" ], function(require, exports, general_methods_10, static_16, app_di_config_1, find_rep_2, cart_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StDIContainer = void 0;
    var StDIContainer = function() {
        function StDIContainer(appName) {
            this.appName = "mainApp";
            this.className = "DI";
            this.subscribeDOMLoaded = general_methods_10.StGeneralMethods.Instance.subscribeDOMLoaded;
            this.appName = appName !== null && appName !== void 0 ? appName : this.appName;
            if (!!window.stApp && window.stApp["DI"]) {
                console.warn("StApp initiated multiple times! Skipping additional init.");
                return;
            }
            window.stApp = {};
            this.endpoint = static_16.StStatic.Instance.endpoint;
            this.mainServices = app_di_config_1.StAppDIConfig.Instance.getServices(this.appName);
            this.mainServices.forEach(function(service) {
                if (service.className) {
                    window.stApp[service.className] = service;
                } else {
                    console.error("Instance has no className: ", service);
                }
            });
            this.init();
        }
        Object.defineProperty(StDIContainer, "Instance", {
            get: function() {
                if (!this._instance) {
                    this._instance = new this();
                }
                window.stApp["DI"] = this._instance;
                return this._instance;
            },
            enumerable: false,
            configurable: true
        });
        StDIContainer.prototype.init = function() {
            general_methods_10.StGeneralMethods.Instance.initDOMLoaded();
            window.onclick = function(e) {
                find_rep_2.StFindRep.Instance.windowModalsClose(e);
                cart_2.StCart.Instance.windowTermsModalClose(e);
            };
        };
        return StDIContainer;
    }();
    exports.StDIContainer = StDIContainer;
});

define("general-methods/initRetry", [ "require", "exports", "static/static" ], function(require, exports, static_17) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StInitRetry = void 0;
    var StInitRetry = function() {
        function StInitRetry() {
            var _this_1 = this;
            this.className = "stInitRetry";
            this.recursiveInitRetry = 0;
            this.timeout = 200;
            this.initWithCondition = function(params) {
                var _this = _this_1;
                var def = {
                    conditionGeneratorParams: [],
                    callbackParams: [],
                    noOfRetries: 6
                };
                var completeParams = __assign(__assign({}, def), params);
                var initCondition = completeParams.conditionGenerator.apply(_this, completeParams.conditionGeneratorParams);
                if (initCondition) {
                    completeParams.callback.apply(_this, completeParams.callbackParams);
                } else {
                    setTimeout(function() {
                        if (_this.recursiveInitRetry < completeParams.noOfRetries) {
                            _this.recursiveInitRetry++;
                            _this.initWithCondition(completeParams);
                        }
                    }, _this_1.timeout);
                }
            };
            this.endpoint = static_17.StStatic.Instance.obtainStaticEndpoints();
        }
        Object.defineProperty(StInitRetry, "Instance", {
            get: function() {
                return this._instance || (this._instance = new this());
            },
            enumerable: false,
            configurable: true
        });
        return StInitRetry;
    }();
    exports.StInitRetry = StInitRetry;
});

define("general-methods/shopify-ajax", [ "require", "exports", "static/static" ], function(require, exports, static_18) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StShopifyAjax = void 0;
    var StShopifyAjax = function() {
        function StShopifyAjax() {
            var _this = this;
            this.className = "stShopifyAjax";
            this.updateCartAttributes = function(attributes, callback, callbackParams) {
                if (callback === void 0) {
                    callback = function() {};
                }
                if (callbackParams === void 0) {
                    callbackParams = [];
                }
                if (!!attributes) {
                    var fnReference_1 = _this;
                    var request_2 = new XMLHttpRequest();
                    request_2.open("POST", "/cart/update.js", true);
                    request_2.withCredentials = true;
                    request_2.setRequestHeader("Content-Type", "application/json");
                    request_2.onreadystatechange = function() {
                        if (request_2.readyState === 4) {
                            try {
                                var resp = JSON.parse(request_2.response);
                                callbackParams.unshift(resp);
                                callback.apply(fnReference_1, callbackParams);
                            } catch (e) {
                                console.error(e);
                                console.error("Failed to update shopify cart attributes!");
                            }
                        }
                    };
                    request_2.send(JSON.stringify({
                        attributes: attributes
                    }));
                }
            };
            this.endpoint = static_18.StStatic.Instance.obtainStaticEndpoints();
        }
        Object.defineProperty(StShopifyAjax, "Instance", {
            get: function() {
                return this._instance || (this._instance = new this());
            },
            enumerable: false,
            configurable: true
        });
        return StShopifyAjax;
    }();
    exports.StShopifyAjax = StShopifyAjax;
});

define("helpers/button-actions", [ "require", "exports", "static/static" ], function(require, exports, static_19) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StButtonActions = void 0;
    var StButtonActions = function() {
        function StButtonActions() {
            var _this = this;
            this.className = "stButtonActions";
            this.enable = function(button) {
                if (!!button) {
                    button.removeAttribute("disabled");
                    button.classList.remove("st-disabled");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            this.disable = function(button) {
                if (!!button) {
                    button.setAttribute("disabled", "");
                    button.classList.add("st-disabled");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            this.addLoader = function(button) {
                if (!!button) {
                    button.classList.add("st-loading");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            this.removeLoader = function(button) {
                if (!!button) {
                    button.classList.remove("st-loading");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            this.toggleState = function(button) {
                if (!!button) {
                    if (_this.isDisabled(button)) {
                        _this.enable(button);
                    } else {
                        _this.disable(button);
                    }
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            this.toggleLoader = function(button) {
                if (!!button) {
                    if (_this.isLoading(button)) {
                        _this.removeLoader(button);
                    } else {
                        _this.addLoader(button);
                    }
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            this.prevent = function(button) {
                if (!!button) {
                    _this.disable(button);
                    _this.addLoader(button);
                    button.classList.add("st-blocked");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            this.allow = function(button) {
                if (!!button) {
                    _this.enable(button);
                    _this.removeLoader(button);
                    button.classList.remove("st-blocked");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            this.isBlocked = function(button) {
                return button.classList.contains("st-blocked");
            };
            this.isLoading = function(button) {
                return button.classList.contains("st-loading");
            };
            this.isDisabled = function(button) {
                return button.classList.contains("st-disabled");
            };
            this.endpoint = static_19.StStatic.Instance.obtainStaticEndpoints();
        }
        Object.defineProperty(StButtonActions, "Instance", {
            get: function() {
                return this._instance || (this._instance = new this());
            },
            enumerable: false,
            configurable: true
        });
        return StButtonActions;
    }();
    exports.StButtonActions = StButtonActions;
});

define("helpers/cart-manipulations", [ "require", "exports", "static/static", "general-methods/ajax" ], function(require, exports, static_20, ajax_13) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCartManipulations = void 0;
    var StCartManipulations = function() {
        function StCartManipulations() {
            var _this_1 = this;
            this.className = "stCartManipulations";
            this.setAliasToCart = function(als, fullName, enrollmentCheckout) {
                var _this = _this_1;
                window.shopifyCartData.attributes.als = als;
                window.shopifyCartData.attributes.discountCode = als;
                if (fullName && typeof fullName != "undefined" && als !== "1") {
                    window.shopifyCartData.attributes.fullName = fullName;
                } else {
                    window.shopifyCartData.attributes.fullName = " NUVITA";
                }
                var enrollmentCheckoutNexPage = enrollmentCheckout && enrollmentCheckout != "undefined" ? true : false;
                window.shopifyCartData.attributes.enrollmentCheckout = enrollmentCheckoutNexPage;
                _this.ajax.send({
                    endpoint: "/cart.js",
                    method: "post",
                    contentType: "json",
                    data: {
                        attributes: {
                            als: als,
                            discountCode: als,
                            fullName: fullName,
                            enrollmentCheckout: enrollmentCheckoutNexPage
                        }
                    },
                    callback: function(response, request) {}
                });
            };
            this.endpoint = static_20.StStatic.Instance.obtainStaticEndpoints();
            this.cart = static_20.StStatic.Instance.obtainCart();
            this.ajax = ajax_13.StAjax.Instance;
        }
        Object.defineProperty(StCartManipulations, "Instance", {
            get: function() {
                return this._instance || (this._instance = new this());
            },
            enumerable: false,
            configurable: true
        });
        StCartManipulations.prototype.init = function() {};
        return StCartManipulations;
    }();
    exports.StCartManipulations = StCartManipulations;
});

define("helpers/cookies", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCookies = void 0;
    var StCookies = function() {
        function StCookies() {
            this.className = "stCookies";
            this.init = function() {};
            this.getCookie = function(cname) {
                var name = cname + "=";
                var decodedCookie = decodeURIComponent(document.cookie);
                var ca = decodedCookie.split(";");
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == " ") {
                        c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                        return c.substring(name.length, c.length);
                    }
                }
                return "";
            };
            this.setCookies = function(cname, cvalue) {
                document.cookie = cname + "=" + cvalue + ";" + ";path=/";
            };
            this.clearCookie = function(cname) {
                document.cookie = cname + "= ;path=/";
            };
        }
        Object.defineProperty(StCookies, "Instance", {
            get: function() {
                return this._instance || (this._instance = new this());
            },
            enumerable: false,
            configurable: true
        });
        return StCookies;
    }();
    exports.StCookies = StCookies;
});

define("helpers/loader", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StLoader = void 0;
    var StLoader = function() {
        function StLoader() {
            this.className = "stLoader";
            this.init = function() {};
            this.on = function(triggerBtn) {
                if (!!triggerBtn && !triggerBtn.classList.contains("nuv_loader-active")) {
                    triggerBtn.classList.add("nuv_loader-active");
                }
            };
            this.off = function(triggerBtn) {
                if (!!triggerBtn && triggerBtn.classList.contains("nuv_loader-active")) {
                    triggerBtn.classList.remove("nuv_loader-active");
                }
            };
        }
        Object.defineProperty(StLoader, "Instance", {
            get: function() {
                return this._instance || (this._instance = new this());
            },
            enumerable: false,
            configurable: true
        });
        return StLoader;
    }();
    exports.StLoader = StLoader;
});

(function() {
    "use strict";
    class StApp extends HTMLElement {
        constructor() {
            super();
            if (!window.stAppInit) {
                var appName = this.getAttribute("data-app");
                require([ "di-container/di-container" ], function(module) {
                    window.stAppInit = true;
                    module.StDIContainer._instance = new module.StDIContainer(appName);
                    module.StDIContainer.Instance.appName = appName;
                    window.RSMainInstance.init();
                });
            }
        }
    }
    customElements.define("st-app", StApp);
})();

(function() {
    "use strict";
    function rs() {
        var context = this;
        context.itemLoaded = false;
        context.injectableReferences = [];
        context.init = function() {
            if (document.readyState === "interactive" || document.readyState === "complete") {
                context.itemLoaded = true;
                context.runApp();
            } else {
                document.addEventListener("readystatechange", function(event) {
                    if (document.readyState === "interactive") {
                        context.itemLoaded = true;
                        context.runApp();
                    }
                }, false);
            }
        };
        context.injectReference = function(classNameString, ref) {
            if (context.itemLoaded) {
                context.doInject({
                    ref: ref,
                    name: classNameString
                });
                if (ref.init) {
                    ref.init();
                }
            } else {
                context.injectableReferences.push({
                    ref: ref,
                    name: classNameString
                });
            }
            return ref;
        };
        context.doInject = function(injectable) {
            window.stApp[injectable.name] = injectable.ref;
        };
        context.runApp = function() {
            for (var i = 0; i < context.injectableReferences.length; i++) {
                context.doInject(context.injectableReferences[i]);
                if (context.injectableReferences[i].ref.init) {
                    context.injectableReferences[i].ref.init();
                }
            }
            context.itemLoaded = true;
            delete context.injectableReferences;
        };
        return this;
    }
    window.RSMainInstance = new rs();
})();

window.define = null;
//# sourceMappingURL=../../middleware/js/_compiled-ts.js.map